import _defineProperty from "/Users/agustinpagnoni/Laburo/landing/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/agustinpagnoni/Laburo/landing/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/agustinpagnoni/Laburo/landing/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useContext, createContext, useRef, useLayoutEffect } from 'react';
import styled, { css, ThemeProvider as ThemeProvider$1, createGlobalStyle, useTheme, keyframes } from 'styled-components';
import { LinkExternalIcon, PersonIcon, NotificationsActiveIcon, NotificationsIcon, IncreaseLogo, ArrowDropdownUp, ArrowDropdownDown, MenuIcon, CloseIcon, CancelIcon, WarningCircleIcon, MailIcon, CheckIcon, MagnifierIcon, EyeSlashedIcon, EyeIcon, MdiArrowUpIcon, ArrowLeftIcon, ArrowRightIcon, EventIcon, FilterFilledIcon, FilterEmptyIcon, EllipsisIcon, NoDataIcon } from '@increasecard/icons';
import Popup from 'reactjs-popup';
import es from 'date-fns/locale/es';
import { format, formatDistance, parse as parse$1 } from 'date-fns';
import ReactDOM from 'react-dom';
import Calendar from 'react-calendar';
import format$1 from 'date-fns/format';
import parse from 'date-fns/parse';
import { RemoveScrollBar } from 'react-remove-scroll-bar';
import { CSSTransition } from 'react-transition-group';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var colors = {
  brandWhite: {
    regular: '#ffffff',
    light: '#F5F5F5',
    medium: '#D8D8D8',
    bold: '#B1B1B1'
  },
  brandBlack: {
    regular: '#182026',
    light: '#44494D',
    medium: '#14191C',
    bold: '#000000'
  },
  brandGreen: {
    regular: '#01A77B',
    light: '#D1F2E7',
    medium: '#01A77B',
    bold: '#0D624C'
  },
  brandBlue: {
    regular: '#243568',
    light: '#667296',
    medium: '#404B6F',
    bold: '#192448'
  },
  sky: {
    regular: '#0F6BFF',
    light: '#87B5FF',
    medium: '#4775BF',
    bold: '#07357F'
  },
  nightSky: {
    regular: '#2B62BA',
    light: '#648CCC',
    medium: '#245199',
    bold: '#183666'
  },
  blueGum: {
    regular: '#239DCE',
    light: '#73C0DF',
    medium: '#208FBC',
    bold: '#176484'
  },
  eter: {
    regular: '#D0F6DD',
    light: '#DCF8E6',
    medium: '#BEE0C9',
    bold: '#ABCAB5'
  },
  liquen: {
    regular: '#43B7B7',
    light: '#76CACA',
    medium: '#3DA7A7',
    bold: '#318686'
  },
  coral: {
    regular: '#FF6F61',
    light: '#FF968C',
    medium: '#E86559',
    bold: '#BA5147'
  },
  sol: {
    regular: '#FFAC30',
    light: '#F9B96F',
    medium: '#D29249',
    bold: '#AB6B22'
  },
  alerta: {
    regular: '#E71321',
    light: '#F38990',
    medium: '#B34950',
    bold: '#730910'
  }
};

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 10px;\n    line-height: 14px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 10px;\n    letter-spacing: 0.09em;\n    line-height: 12px;\n    text-transform: uppercase;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 12px;\n    letter-spacing: 0.06em;\n    line-height: 15px;\n    text-transform: uppercase;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 13px;\n    letter-spacing: -0.003em;\n    line-height: 16px;\n    font-feature-settings: 'tnum' 1;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 16px;\n    letter-spacing: -0.011em;\n    line-height: 1.5;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 16px;\n    letter-spacing: -0.011em;\n    line-height: 19px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 20px;\n    letter-spacing: -0.012em;\n    line-height: 30px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 32px;\n    letter-spacing: -0.04em;\n    line-height: 40px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 42px;\n    line-height: 51px;\n    font-weight: bold;\n    letter-spacing: -0.04em;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var fontFamily = 'Inter var, Inter, sans-serif';
/* Unfortunately the styled components babel plugin does not automatically
 * add PURE annotation for the `css` function :(
 */

var typography = {
  superHeader: /*#__PURE__*/css( /*#__PURE__*/_templateObject(), fontFamily),
  H1: /*#__PURE__*/css( /*#__PURE__*/_templateObject2(), fontFamily),
  H2: /*#__PURE__*/css( /*#__PURE__*/_templateObject3(), fontFamily),
  H3: /*#__PURE__*/css( /*#__PURE__*/_templateObject4(), fontFamily),
  body: /*#__PURE__*/css( /*#__PURE__*/_templateObject5(), fontFamily),
  cell: /*#__PURE__*/css( /*#__PURE__*/_templateObject6(), fontFamily),
  label: /*#__PURE__*/css( /*#__PURE__*/_templateObject7(), fontFamily),
  inputLabel: /*#__PURE__*/css( /*#__PURE__*/_templateObject8(), fontFamily),
  caption: /*#__PURE__*/css( /*#__PURE__*/_templateObject9(), fontFamily)
};
var breakpoints = {
  sm: '320px',
  md: '640px',
  lg: '1280px',
  xl: '1440px',
  xxl: '1600px'
};
var shadows = {
  rest: "0px 1px 3px rgba(24, 32, 38, 0.09), 0px 2px 2px rgba(24, 32, 38, 0.06),\n    0px 3px 2px rgba(24, 32, 38, 0.07)",
  elevate: "0px 8px 10px rgba(24, 32, 38, 0.09), 0px 6px 30px rgba(24, 32, 38, 0.11), 0px 16px 24px rgba(24, 32, 38, 0.13)",
  elevateCast: "0px 3px 9px rgba(24, 32, 38, 0.18)",
  pressed: "0px 1px 3px rgba(24, 32, 38, 0.18), 0px 2px 2px rgba(24, 32, 38, 0.11), 0px 0px 2px rgba(24, 32, 38, 0.13)"
};
var productColors = {
  card: {
    light: '#DAEFF7',
    light70: '#a4dff4',
    light50: '#80d3f2',
    light30: '#5cc9f0',
    regular: '#26b8ed',
    dark30: '#1b8dc2',
    dark50: '#1370a5',
    dark70: '#0b5388',
    dark: '#00275c',
    accent: '#00edff'
  },
  pay: {
    light: '#e6f8f8',
    light70: '#a1e4e3',
    light50: '#73d7d5',
    light30: '#45c9c8',
    regular: '#00b5b3',
    dark30: '#009499',
    dark50: '#007f87',
    dark70: '#006975',
    dark: '#00485b',
    accent: '#00f2de'
  },
  match: {
    light: '#e7d9fc',
    light70: '#c9bdfd',
    light50: '#b4aabfd',
    light30: '#a098fe',
    regular: '#827cff',
    dark30: '#7163ce',
    dark50: '#6552ad',
    dark70: '#5a418d',
    dark: '#49285c',
    accent: '#c8a1ff'
  },
  count: {
    light: '#ffe4d1',
    light70: '#fbd1a8',
    light50: '#f9c48c',
    light30: '#f6b770',
    regular: '#f2a447',
    dark30: '#e28940',
    dark50: '#d7783c',
    dark70: '#cc6638',
    dark: '#bc4b31',
    accent: '#ffda7c'
  }
};
var increaseColors = {
  light: '#d1f2e7',
  light70: '#93dbc7',
  light50: '#69ccb1',
  light30: '#3fbd9b',
  regular: '#01a77b',
  dark30: '#05926d',
  dark50: '#078464',
  dark70: '#09775a',
  dark: '#0d624c',
  accent: '#69f5a5'
};

var colorsNew = function colorsNew(productName) {
  return _extends({
    increase: increaseColors,
    product: productName ? productColors[productName] : increaseColors,
    gray: {
      white: '#ffffff',
      graySLight: '#fbfbfb',
      grayLight: '#f5f5f5',
      grayMedium: '#d8d8d8',
      grayBold: '#b1b1b1',
      blackSLight: '#6c7174',
      blackLight: '#42484d',
      blackMedium: '#2d3439',
      black: '#182026',
      subtleBorder: 'rgba(24, 32, 38, 0.16)'
    },
    coral: {
      sLight: '#ffd1cc',
      light: '#ff968c',
      regular: '#ff6f61',
      medium: '#e05a4d',
      dark: '#c83f32'
    },
    primaryAction: {
      regular: '#0f6bff',
      dark: '#07357f',
      alpha: 'rgba(15, 107, 255, 0.07)'
    },
    coralAlert: {
      regular: '#ff402e',
      dark: '#b80f00',
      alpha: 'rgba(255, 64, 46, 0.07)'
    }
  }, productColors);
};

var Theme = function Theme(productName) {
  return {
    colors: colors,
    colorsNew: colorsNew(productName),
    typography: typography,
    breakpoints: breakpoints,
    shadows: shadows
  };
};

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  html {\n    color: ", ";\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var BaseFontStyles = /*#__PURE__*/createGlobalStyle( /*#__PURE__*/_templateObject$1(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorsNew.gray.black;
});

var ThemeProvider = function ThemeProvider(_ref4) {
  var children = _ref4.children,
      theme = _ref4.theme,
      productName = _ref4.productName;
  var effectiveTheme = Object.assign({}, Theme(productName), theme);
  return React.createElement(React.Fragment, null, React.createElement(ThemeProvider$1, {
    theme: effectiveTheme
  }, React.createElement(React.Fragment, null, React.createElement(BaseFontStyles, null), children)));
};

function color(name, variant) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors[name][variant];
  };
}

function typography$1(name) {
  return function (_ref6) {
    var theme = _ref6.theme;
    return theme.typography[name];
  };
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n          border-bottom: 6px solid ", ";\n          border-top: 6px solid transparent;\n        "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  background: ", ";\n  color: ", ";\n  border: none;\n  display: flex;\n  align-items: center;\n  ", ";\n  font-weight: 500;\n  height: 100%;\n  text-transform: uppercase;\n  ", "\n\n  &:not(:disabled) {\n    ", "\n  }\n  &:hover:not(:disabled) {\n    color: ", ";\n  }\n\n  * + & {\n    margin-left: 40px;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var Tab = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$2(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorsNew.gray.black;
}, function (_ref8) {
  var active = _ref8.active,
      theme = _ref8.theme;
  return active ? theme.colorsNew.gray.white : theme.colorsNew.gray.grayBold;
}, /*#__PURE__*/typography$1('label'), function (_ref9) {
  var active = _ref9.active,
      theme = _ref9.theme;
  return active ? css(_templateObject2$1(), theme.colorsNew.gray.white) : '';
}, function (_ref10) {
  var active = _ref10.active;
  return !active && 'cursor: pointer;';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorsNew.gray.white;
});

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background: ", ";\n  width: 100%;\n  height: 56px;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  a {\n    text-decoration: none;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var TabGroup = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$3());
var TabGroupWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$2(), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colorsNew.gray.black;
});

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n  & strong {\n    font-weight: bold;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n  & strong {\n    font-weight: bold;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n  & strong {\n    font-weight: bold;\n  }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: bold;\n  }\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: ", ";\n  font-weight: ", ";\n  font-feature-settings: 'tnum' on;\n\n  & strong {\n    font-weight: bold;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    "]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n  ", "\n  & strong {\n    font-weight: bold;\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  font-weight: ", ";\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var H1 = /*#__PURE__*/styled.h1( /*#__PURE__*/_templateObject$4(), /*#__PURE__*/typography$1('H1'), function (_ref13) {
  var weight = _ref13.weight;
  return weight || 'bold';
});
var H2 = /*#__PURE__*/styled.h2( /*#__PURE__*/_templateObject2$3(), /*#__PURE__*/typography$1('H2'), function (_ref14) {
  var weight = _ref14.weight;
  return weight || 'bold';
});
var H3 = /*#__PURE__*/styled.h3( /*#__PURE__*/_templateObject3$1(), /*#__PURE__*/typography$1('H3'), function (_ref15) {
  var weight = _ref15.weight;
  return weight || 'bold';
});
var SuperHeader = /*#__PURE__*/styled.h1( /*#__PURE__*/_templateObject4$1(), /*#__PURE__*/typography$1('superHeader'), function (_ref16) {
  var weight = _ref16.weight;
  return weight || 'bold';
});
var Paragraph = /*#__PURE__*/styled.p( /*#__PURE__*/_templateObject5$1(), /*#__PURE__*/typography$1('body'), function (_ref17) {
  var weight = _ref17.weight;
  return weight || 'normal';
}, function (_ref18) {
  var ellipsis = _ref18.ellipsis;
  return ellipsis && css(_templateObject6$1());
});
var CellText = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject7$1(), /*#__PURE__*/typography$1('cell'), function (_ref19) {
  var inline = _ref19.inline;
  return inline ? 'inline' : 'block';
}, function (_ref20) {
  var weight = _ref20.weight;
  return weight || 'normal';
});
var InlineText = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject8$1(), /*#__PURE__*/typography$1('body'), function (_ref21) {
  var inline = _ref21.inline;
  return inline ? 'inline' : 'block';
}, function (_ref22) {
  var weight = _ref22.weight;
  return weight || 'normal';
});
var Label = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject9$1(), /*#__PURE__*/typography$1('label'), function (_ref23) {
  var weight = _ref23.weight;
  return weight || '500';
});
var InputLabel = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject10(), /*#__PURE__*/typography$1('inputLabel'), function (_ref24) {
  var weight = _ref24.weight;
  return weight || '500';
});
var Caption = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject11(), /*#__PURE__*/typography$1('caption'), function (_ref25) {
  var weight = _ref25.weight;
  return weight || 'normal';
});

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n      border-bottom-color: ", ";\n      pointer-events: none;\n      background: ", ";\n      box-shadow: ", ";\n    "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px;\n  border-bottom: 6px solid ", ";\n  transition: 0.25s;\n  height: 100%;\n\n  a {\n    color: inherit;\n  }\n\n  .drawer-image {\n    margin-top: 2.5rem;\n  }\n  p {\n    margin: 15px 0 0;\n    font-size: 13px;\n    color: #38f;\n    text-decoration: underline;\n  }\n  &:hover {\n    border-bottom-color: ", ";\n    color: ", ";\n  }\n\n  &:hover h2 {\n    color: ", ";\n  }\n\n  img {\n    height: 34px;\n    width: auto;\n  }\n\n  ", "\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

function ButtonDrawer(_ref) {
  var className = _ref.className,
      href = _ref.href,
      displayName = _ref.displayName,
      description = _ref.description,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "href", "displayName", "description"]);

  return React.createElement("a", Object.assign({
    className: className,
    href: href
  }, rest), React.createElement(H2, null, displayName), description);
}

var StyledButtonDrawer = /*#__PURE__*/styled(ButtonDrawer)( /*#__PURE__*/_templateObject$5(), /*#__PURE__*/typography$1('cell'), function (_ref26) {
  var theme = _ref26.theme;
  return theme.colorsNew.product.light;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colorsNew.primaryAction.regular;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colorsNew.primaryAction.dark;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colorsNew.primaryAction.dark;
}, function (_ref30) {
  var selected = _ref30.selected;
  return selected && css(_templateObject2$4(), function (_ref31) {
    var theme = _ref31.theme;
    return theme.colorsNew.primaryAction.regular;
  }, function (_ref32) {
    var theme = _ref32.theme;
    return theme.colorsNew.gray.white;
  }, function (_ref33) {
    var theme = _ref33.theme;
    return theme.shadows.elevateCast;
  });
});

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  border: none;\n  background: transparent;\n  font: inherit;\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  text-decoration: underline;\n  border-radius: 4px;\n  transition: all 200ms;\n\n  :focus {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  :disabled {\n    opacity: 0.4;\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: none;\n    }\n\n    &:hover:active {\n      text-decoration: underline;\n    }\n\n    &:hover,\n    &:active {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var BasicLink = /*#__PURE__*/styled.a( /*#__PURE__*/_templateObject$6(), function (_ref34) {
  var theme = _ref34.theme,
      variant = _ref34.variant;
  return variant === 'alert' ? theme.colorsNew.coralAlert.regular : theme.colorsNew.primaryAction.regular;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.colorsNew.increase.light;
}, function (_ref36) {
  var theme = _ref36.theme,
      variant = _ref36.variant;
  return variant === 'alert' ? theme.colorsNew.coralAlert.dark : theme.colorsNew.primaryAction.dark;
});

var Link = function Link(props) {
  return React.createElement(BasicLink, Object.assign({}, props), props.children, props.target === '_blank' && // 18px / 13px => 1.385em
  React.createElement(LinkExternalIcon, {
    height: "1.385em",
    style: {
      marginLeft: '1px'
    },
    width: "1.385em"
  }));
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid ", ";\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n\n  .sidebar-link {\n    ", "\n    display: block;\n    padding: 1.25rem;\n    text-decoration: none;\n    text-align: center;\n    white-space: nowrap;\n    color: ", ";\n  }\n\n  .sidebar-link:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  @media (min-width: ", ") {\n    position: relative;\n    border-bottom: none;\n    padding: 0 1.25rem 0 0;\n    margin-bottom: 0;\n    padding-left: 32px;\n    width: 160px;\n    .sidebar-link {\n      padding: 0;\n      margin-bottom: 6px;\n      text-align: left;\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n    &::before {\n      position: absolute;\n      content: '';\n      background-color: ", ";\n      width: 1px;\n      top: 15px;\n      left: 0;\n      bottom: 15px;\n    }\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var SidebarStyled = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$7(), function (_ref37) {
  var theme = _ref37.theme;
  return theme.colorsNew.gray.grayMedium;
}, /*#__PURE__*/typography$1('cell'), function (_ref38) {
  var theme = _ref38.theme;
  return theme.colorsNew.gray.black;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.colorsNew.primaryAction.regular;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.md;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.colorsNew.gray.grayMedium;
});

var SideBarLinks = function SideBarLinks(_ref) {
  var sidebar = _ref.sidebar,
      rest = _objectWithoutPropertiesLoose(_ref, ["sidebar"]);

  return React.createElement(SidebarStyled, Object.assign({}, rest), React.createElement("div", null, sidebar.map(function (item, i) {
    return React.createElement(Link, {
      className: "sidebar-link",
      href: item.url,
      key: i,
      target: item.blank ? 'blank' : undefined
    }, item.label);
  })));
};

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n          grid-row-gap: ", "px;\n        "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n          grid-column-gap: 16px;\n        "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n          grid-column-gap: ", "px;\n        "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n  ", "\n  ", "\n  ", "\n  @media (min-width: ", ") {\n    ", "\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n  "]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var COLUMNS_MOBILE = 2;
var COLUMNS_DESKTOP = 12;

var gridColumns = function gridColumns(columnsNumber, prefix) {
  var styles = "\n    grid-template-columns: repeat(" + columnsNumber + ", 1fr);\n\n    > * {\n      grid-column: span " + columnsNumber + " / span " + columnsNumber + ";\n    }";

  for (var i = 1; i <= columnsNumber; i += 1) {
    styles += "> .grid-span-" + prefix + "-" + i + ",\n        .span-" + prefix + "-" + i + " {\n          grid-column-start: span " + i + ";\n          grid-column-end: span " + i + ";\n      }";
  }

  for (var _i = 1; _i <= columnsNumber; _i += 1) {
    styles += "\n      > .grid-start-" + prefix + "-" + _i + " {\n        grid-column-start: " + _i + ";\n      }";
  }

  return /*#__PURE__*/css(_templateObject$8(), styles);
};

var Grid = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$5(), function (_ref42) {
  var columnGap = _ref42.columnGap;
  return columnGap ? css(_templateObject3$2(), columnGap * 16) : css(_templateObject4$2());
}, function (_ref43) {
  var rowGap = _ref43.rowGap;
  return rowGap ? css(_templateObject5$2(), rowGap * 8) : null;
}, /*#__PURE__*/gridColumns(COLUMNS_MOBILE, 'mobile'), function (_ref44) {
  var theme = _ref44.theme;
  return theme.breakpoints.md;
}, /*#__PURE__*/gridColumns(COLUMNS_DESKTOP, 'desktop'));

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  .sl-container {\n    display: inline-flex;\n    align-items: center;\n    width: 210px;\n    padding: 10px;\n    border-radius: 9px;\n    cursor: pointer;\n    text-decoration: none;\n    &:hover {\n      color: ", ";\n      ", " {\n        color: ", ";\n      }\n    }\n\n    .sl-title {\n      ", ";\n      line-height: 1.25rem;\n      margin: 0.25rem 0;\n      text-align: center;\n    }\n    .sl-text {\n      margin: 0;\n      ", ";\n      text-align: center;\n    }\n\n    ", " {\n      margin-right: 10px;\n    }\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  svg {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  min-height: 100px;\n  transition: 0.25s;\n  transform: translateY(", ");\n  z-index: 1;\n  box-shadow: ", ";\n  overflow-y: auto;\n  display: flex;\n  transform: translateY(", ");\n  height: auto;\n  .container {\n    height: 140px;\n    padding: 0 26px;\n  }\n\n  a {\n    color: inherit;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var NavMenu = /*#__PURE__*/styled(Grid)( /*#__PURE__*/_templateObject$9(), function (_ref45) {
  var theme = _ref45.theme;
  return theme.colorsNew.gray.white;
}, function (_ref46) {
  var visible = _ref46.visible;
  return visible ? '46px' : '-100%';
}, function (_ref47) {
  var visible = _ref47.visible;
  return visible ? 'rgba(0, 0, 0, 0.05) 0px 2px 4px' : 'none';
}, function (_ref48) {
  var visible = _ref48.visible;
  return visible ? '56px' : '-100%';
});
var IconWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$6());
var SecondLevelActions = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$3(), function (_ref49) {
  var theme = _ref49.theme;
  return theme.colorsNew.primaryAction.regular;
}, Paragraph, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colorsNew.primaryAction.regular;
}, /*#__PURE__*/typography$1('body'), /*#__PURE__*/typography$1('cell'), IconWrapper);
var mapName = {
  conciliation: 'match',
  card: 'card',
  pay: 'pay',
  calculadora: 'count'
};

function MainNavMenu(_ref51) {
  var country = _ref51.country,
      onProductAcquire = _ref51.onProductAcquire,
      products = _ref51.products,
      secondLevel = _ref51.secondLevel,
      sidebar = _ref51.sidebar,
      visible = _ref51.visible;

  var handleProductAcquire = function handleProductAcquire(product) {
    return function (event) {
      event.preventDefault();
      onProductAcquire(product);
    };
  };

  return React.createElement(NavMenu, {
    visible: visible
  }, React.createElement(Grid, {
    className: "container",
    columnGap: 2
  }, products.all.filter(function (_ref52) {
    var countries = _ref52.countries;
    return countries.includes(country);
  }).map(function (product) {
    var enabled = product.is_free || products.active[country].includes(product.name);
    return React.createElement(ThemeProvider, {
      key: product.name,
      productName: mapName[product.name]
    }, React.createElement(StyledButtonDrawer, {
      className: "span-desktop-2",
      description: product.description,
      displayName: product.display_name,
      href: enabled ? product.uri : '#',
      onClick: !enabled ? handleProductAcquire(product) : undefined,
      selected: products.current === product.name
    }));
  }), React.createElement(SideBarLinks, {
    className: "span-desktop-2",
    sidebar: sidebar
  }), React.createElement(SecondLevelActions, {
    className: "span-desktop-2"
  }, secondLevel.map(function (item, i) {
    return React.createElement("a", {
      className: "sl-container",
      href: item.url,
      key: i,
      target: "blank"
    }, React.createElement(IconWrapper, null, item.logo), React.createElement("div", null, React.createElement(Paragraph, {
      style: {
        fontWeight: 'bold'
      }
    }, item.name), React.createElement("p", {
      className: "sl-text"
    }, item.text)));
  }))));
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 15px;\n  z-index: 4;\n  color: ", ";\n  font-size: 13px;\n  line-height: 24px;\n  .user {\n    font-size: 16px;\n    line-height: 19px;\n    font-weight: 600;\n    padding: 0 8px;\n    margin-bottom: 3px;\n  }\n  a {\n    color: ", ";\n    border-radius: 4px;\n    padding: 8px;\n    display: block;\n    ", "\n  }\n\n  a:hover {\n    text-decoration: none;\n    background: ", ";\n  }\n\n  hr {\n    background: transparent;\n    margin: 0;\n    margin-bottom: 8px;\n    padding: 8px 0 0;\n    border: none;\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var PopupMenu = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$a(), function (_ref53) {
  var theme = _ref53.theme;
  return theme.colorsNew.gray.black;
}, function (_ref54) {
  var theme = _ref54.theme;
  return theme.colorsNew.gray.black;
}, /*#__PURE__*/typography$1('cell'), function (_ref55) {
  var theme = _ref55.theme;
  return theme.colorsNew.gray.grayLight;
}, function (_ref56) {
  var theme = _ref56.theme;
  return theme.colorsNew.gray.grayMedium;
});

function MenuProfile(_ref57) {
  var urls = _ref57.urls,
      profileLinks = _ref57.profileLinks,
      userName = _ref57.userName;
  var theme = useTheme(); // TODO(santi698): Remove Popup and use FloatingMenu here

  return React.createElement(Popup, {
    arrowStyle: {
      boxShadow: '5px 5px 15px rgba(24, 32, 38, 0.18)'
    },
    closeOnDocumentClick: true,
    contentStyle: {
      zIndex: 4,
      padding: 0,
      boxShadow: theme.shadows.elevateCast,
      border: 'none'
    },
    position: "bottom right",
    trigger: function trigger() {
      return React.createElement(HeaderButton, null, React.createElement(PersonIcon, {
        height: "20",
        width: "20"
      }), React.createElement("span", null, "Mi Cuenta"));
    }
  }, React.createElement(PopupMenu, null, React.createElement("div", {
    className: "user"
  }, userName), React.createElement(Link, {
    href: urls.platform + "/settings"
  }, "Ajustes de cuenta"), profileLinks.length > 0 && React.createElement(React.Fragment, null, React.createElement("hr", null), profileLinks.map(function (link) {
    return React.createElement(Link, {
      href: link.url,
      key: link.url,
      target: link.blank ? '_blank' : '_self'
    }, link.label);
  })), React.createElement("hr", null), React.createElement(Link, {
    href: urls.auth + "/logout"
  }, "Cerrar Sesi\xF3n")));
}
/**
 * Hook that alerts clicks outside of the passed ref.
 *
 * Source: https://stackoverflow.com/a/42234988
 */


function useOnClickOutside( // eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, onClickOutside) {
  /**
   * Alert if clicked on outside of element
   */
  function handleClickOutside(event) {
    if (ref instanceof Array) {
      if (ref.every(function (r) {
        return r.current && !r.current.contains(event.target);
      })) {
        onClickOutside(event);
      }

      return;
    }

    if (ref.current && !ref.current.contains(event.target)) {
      onClickOutside(event);
    }
  }

  useEffect(function () {
    if (typeof document === 'undefined') return;
    document.addEventListener('mousedown', handleClickOutside); // eslint-disable-next-line consistent-return

    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
} //                 similar)

/**
 * A ReactDOM.createPortal wrapper which renders null when on SSR to avoid failing due to
 * `document` being undefined
 */


function UniversalPortal(_ref58) {
  var children = _ref58.children,
      selector = _ref58.selector;

  var _useState = useState(null),
      element = _useState[0],
      setElement = _useState[1];

  useEffect(function () {
    if (typeof document === 'undefined') return;
    var e = document.querySelector(selector);
    setElement(e);
  }, []);
  if (element === null) return null;
  return ReactDOM.createPortal(children, element);
}

var IsInsidePortalContext = /*#__PURE__*/createContext(false);

function IsInsidePortalProvider(_ref59) {
  var children = _ref59.children;
  return React.createElement(IsInsidePortalContext.Provider, {
    value: true
  }, children);
}

function useIsInsidePortal() {
  return useContext(IsInsidePortalContext);
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 3;\n  ", "\n  ", "\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$b());
var MenuWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$7(), function (_ref60) {
  var top = _ref60.top;
  return top ? "top: " + top + ";" : null;
}, function (_ref61) {
  var left = _ref61.left;
  return left ? "left: " + left + ";" : null;
});
/**
 * A generic dropdown menu which is compliant with the
 * [WAI-ARIA guidelines](https://www.w3.org/TR/wai-aria-practices/#wai-aria-roles-states-and-properties-14)
 *
 * Please pass all props received in the renderTrigger render prop to the rendered trigger element.
 * */

function FloatingMenu(_ref) {
  var children = _ref.children,
      renderTrigger = _ref.renderTrigger,
      onClickOutside = _ref.onClickOutside,
      _ref$closeOnClickOuts = _ref.closeOnClickOutside,
      closeOnClickOutside = _ref$closeOnClickOuts === void 0 ? true : _ref$closeOnClickOuts,
      _ref$onmountOnHide = _ref.onmountOnHide,
      onmountOnHide = _ref$onmountOnHide === void 0 ? true : _ref$onmountOnHide,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "renderTrigger", "onClickOutside", "closeOnClickOutside", "onmountOnHide"]);

  var isInsidePortal = useIsInsidePortal();

  var _useState = useState(false),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var _useState2 = useState({}),
      menuPosition = _useState2[0],
      setMenuPosition = _useState2[1];

  var wrapperRef = useRef(null);
  var menuRef = useRef(null);
  useOnClickOutside([menuRef, wrapperRef], function () {
    if (onClickOutside) onClickOutside();

    if (expanded && closeOnClickOutside) {
      setExpanded(function (expanded) {
        return !expanded;
      });
    }
  });
  useLayoutEffect(function () {
    if (wrapperRef.current === null || isInsidePortal) return;
    var wrapperElement = wrapperRef.current;

    var positionMenu = function positionMenu() {
      var wrapperRect = wrapperElement.getBoundingClientRect();
      setMenuPosition({
        top: wrapperRect.top + wrapperRect.height + window.scrollY + "px",
        left: wrapperRect.left + "px"
      });
    };

    positionMenu();
    window.addEventListener('resize', positionMenu); // eslint-disable-next-line consistent-return

    return function () {
      window.removeEventListener('resize', positionMenu);
    };
  }, [isInsidePortal]);

  var toggleShowMenu = function toggleShowMenu() {
    return setExpanded(function (e) {
      return !e;
    });
  };

  var setShowMenu = function setShowMenu(value) {
    return setExpanded(value);
  };

  var controllerProps = {
    toggleShowMenu: toggleShowMenu,
    setShowMenu: setShowMenu,
    showMenu: expanded,
    wrapperRef: wrapperRef
  };
  var menu = React.createElement(MenuWrapper, Object.assign({
    ref: menuRef
  }, menuPosition), onmountOnHide && expanded && children(controllerProps), !onmountOnHide && React.createElement("div", {
    style: {
      opacity: expanded ? 1 : 0,
      visibility: expanded ? 'visible' : 'hidden'
    }
  }, children(controllerProps)));
  return React.createElement(Wrapper, Object.assign({
    ref: wrapperRef
  }, rest), renderTrigger({
    'aria-expanded': expanded,
    'aria-haspopup': true
  }, controllerProps), isInsidePortal ? menu : React.createElement(IsInsidePortalProvider, null, React.createElement(UniversalPortal, {
    selector: "body"
  }, menu)));
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 360px;\n  padding: 18px;\n\n  :not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  background: ", ";\n  right: -40px;\n  top: 4px;\n  box-shadow: ", ";\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var CreatedAt = /*#__PURE__*/styled(Paragraph)( /*#__PURE__*/_templateObject$c(), function (_ref62) {
  var theme = _ref62.theme;
  return theme.colorsNew.gray.grayBold;
});
var Menu = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$8(), function (_ref63) {
  var theme = _ref63.theme;
  return theme.colorsNew.gray.white;
}, function (_ref64) {
  var theme = _ref64.theme;
  return theme.shadows.elevateCast;
});
var NotificationElement = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$4(), function (_ref65) {
  var theme = _ref65.theme;
  return theme.colorsNew.gray.grayMedium;
});
var Separator = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$3(), function (_ref66) {
  var theme = _ref66.theme;
  return theme.colorsNew.gray.grayMedium;
});

function NotificationsButton(_ref67) {
  var notifications = _ref67.notifications,
      onNotificationsOpen = _ref67.onNotificationsOpen;
  var theme = useTheme();
  var hasNotifications = notifications.length > 0;
  var hasUnread = notifications.some(function (_ref68) {
    var read = _ref68.read;
    return !read;
  });
  var label = hasNotifications ? 'Ver notificaciones' : 'No hay notificaciones';
  return React.createElement(FloatingMenu, {
    renderTrigger: function renderTrigger(props, _ref69) {
      var toggleShowMenu = _ref69.toggleShowMenu,
          showMenu = _ref69.showMenu;
      return React.createElement(HeaderButton, Object.assign({}, props, {
        "aria-label": label,
        disabled: !hasNotifications,
        onClick: function onClick() {
          if (onNotificationsOpen && !showMenu) onNotificationsOpen();
          toggleShowMenu();
        },
        title: label
      }), hasUnread ? React.createElement(NotificationsActiveIcon, {
        height: "24",
        width: "24"
      }) : React.createElement(NotificationsIcon, {
        height: "24",
        style: {
          color: hasNotifications ? 'currentColor' : theme.colorsNew.gray.grayMedium
        },
        width: "24"
      }));
    }
  }, function () {
    return React.createElement(Menu, null, React.createElement(H3, {
      style: {
        padding: '18px'
      }
    }, "Notificaciones"), React.createElement(Separator, null), notifications.sort(function (n1, n2) {
      return n2.createdAt.valueOf() - n1.createdAt.valueOf();
    }).map(function (_ref70) {
      var id = _ref70.id,
          createdAt = _ref70.createdAt,
          title = _ref70.title,
          body = _ref70.body;
      return React.createElement(NotificationElement, {
        key: id
      }, React.createElement(CreatedAt, {
        title: format(createdAt, 'dd/MM/yyyy HH:mm')
      }, "Hace ", formatDistance(createdAt, new Date(), {
        locale: es
      })), title && React.createElement(Paragraph, null, React.createElement("strong", null, title)), React.createElement(Paragraph, null, body));
    }));
  });
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 20px;\n  border-right: 1px solid ", ";\n  margin: 0 8px;\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  .alerts {\n    margin-right: 15px;\n    padding-right: 15px;\n    border-right: 1px solid ", ";\n    color: ", ";\n  }\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  user-select: none;\n  color: ", ";\n  :focus {\n    outline: none;\n  }\n  .logo {\n    height: 25px;\n    width: 25px;\n  }\n  .brandName {\n    ", "\n    font-weight: bold;\n    margin: 0 8px 0 8px;\n  }\n\n  .drawerToggle {\n    display: flex;\n    align-items: center;\n    color: ", ";\n  }\n\n  .drawerToggle path {\n    fill: ", ";\n  }\n\n  .drawerToggle:hover {\n    color: ", ";\n  }\n\n  .drawerToggle:hover path {\n    fill: ", ";\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: auto;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  position: relative;\n  z-index: 2;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 56px;\n  padding: 0 26px;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  margin: 0px;\n  padding: 0px;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  padding: 6px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 40px;\n\n  > svg:not(:only-child) {\n    margin-right: 6px;\n  }\n\n  :not(:disabled) {\n    cursor: pointer;\n\n    &:focus,\n    &:active,\n    &:hover {\n      outline: none;\n      background: ", ";\n    }\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var HeaderButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$d(), function (_ref71) {
  var theme = _ref71.theme;
  return theme.colorsNew.gray.black;
}, function (_ref72) {
  var theme = _ref72.theme;
  return theme.colorsNew.gray.grayLight;
});
var ApplicationHeaderContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$9());
var ApplicationHeaderWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$5(), function (_ref73) {
  var theme = _ref73.theme;
  return theme.colorsNew.gray.white;
}, function (_ref74) {
  var theme = _ref74.theme;
  return theme.colorsNew.gray.grayMedium;
});
var ApplicationHeaderContent = /*#__PURE__*/styled.nav( /*#__PURE__*/_templateObject4$4());
var LogoWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$3(), function (_ref75) {
  var theme = _ref75.theme;
  return theme.colorsNew.gray.black;
}, /*#__PURE__*/typography$1('H3'), function (_ref76) {
  var isOpen = _ref76.isOpen,
      theme = _ref76.theme;
  return isOpen ? theme.colorsNew.primaryAction.regular : null;
}, function (_ref77) {
  var isOpen = _ref77.isOpen,
      theme = _ref77.theme;
  return isOpen ? theme.colorsNew.primaryAction.regular : null;
}, function (_ref78) {
  var theme = _ref78.theme;
  return theme.colorsNew.primaryAction.regular;
}, function (_ref79) {
  var theme = _ref79.theme;
  return theme.colorsNew.primaryAction.regular;
});
var RightContent = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$2(), function (_ref80) {
  var theme = _ref80.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref81) {
  var theme = _ref81.theme;
  return theme.colorsNew.gray.grayMedium;
});
var Separator$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$2(), function (_ref82) {
  var theme = _ref82.theme;
  return theme.colorsNew.gray.grayBold;
});

function ApplicationHeader(_ref) {
  var products = _ref.products,
      links = _ref.links,
      urls = _ref.urls,
      country = _ref.country,
      onProductAcquire = _ref.onProductAcquire,
      notifications = _ref.notifications,
      onNotificationsOpen = _ref.onNotificationsOpen,
      userName = _ref.userName,
      rest = _objectWithoutPropertiesLoose(_ref, ["products", "links", "urls", "country", "onProductAcquire", "notifications", "onNotificationsOpen", "userName"]);

  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var ref = useRef(null);
  useOnClickOutside(ref, function () {
    if (isOpen) {
      setOpen(!isOpen);
    }
  });
  var product = products.all.find(function (_ref83) {
    var name = _ref83.name;
    return name === products.current;
  });
  var productName = product ? product.display_name : 'Increase';

  var handleClick = function handleClick() {
    return setOpen(function (open) {
      return !open;
    });
  };

  var sidebarLinks = links.sidebar.concat([{
    label: 'Más Productos',
    url: urls.platform + "/",
    blank: false
  }, {
    label: 'Ajustes',
    url: urls.platform + "/settings/",
    blank: false
  }]);
  return React.createElement(ApplicationHeaderContainer, Object.assign({
    ref: ref
  }, rest), React.createElement(MainNavMenu, {
    country: country,
    onProductAcquire: onProductAcquire,
    products: products,
    secondLevel: links.secondLevel,
    sidebar: sidebarLinks,
    visible: isOpen
  }), React.createElement(ApplicationHeaderWrapper, null, React.createElement(ApplicationHeaderContent, null, React.createElement("div", {
    className: "logo"
  }, React.createElement(LogoWrapper, {
    isOpen: isOpen,
    onClick: handleClick
  }, React.createElement(IncreaseLogo, null), React.createElement("div", {
    className: "drawerToggle"
  }, React.createElement("span", {
    className: "brandName"
  }, productName), isOpen ? React.createElement(ArrowDropdownUp, null) : React.createElement(ArrowDropdownDown, null)))), React.createElement(RightContent, null, notifications && React.createElement(React.Fragment, null, React.createElement(NotificationsButton, {
    notifications: notifications,
    onNotificationsOpen: onNotificationsOpen
  }), React.createElement(Separator$1, null)), React.createElement("div", {
    className: "account"
  }, React.createElement(MenuProfile, {
    profileLinks: links.profile,
    urls: urls,
    userName: userName
  }))))));
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  color: ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var MenuLink = /*#__PURE__*/styled(Link)( /*#__PURE__*/_templateObject$e(), /*#__PURE__*/typography$1('cell'), function (_ref84) {
  var theme = _ref84.theme;
  return theme.colorsNew.gray.black;
});

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n      cursor: default;\n    "]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n          :hover {\n            color: ", ";\n          }\n        "]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n          cursor: default;\n          opacity: 0.36;\n        "]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n          color: ", ";\n        "]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  color: ", ";\n  ", ";\n  height: 26px;\n  cursor: pointer;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  border-left: 3px solid ", ";\n  padding-left: 11px;\n\n  &, :hover {\n    text-decoration: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:not(:first-child) {\n    margin-top: 16px;\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin: 16px 0;\n  height: calc(100% - 32px);\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var VerticalNavigation = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$f());
var VerticalNavigationElement = /*#__PURE__*/styled(Link)( /*#__PURE__*/_templateObject2$a(), /*#__PURE__*/typography$1('cell'), function (_ref85) {
  var theme = _ref85.theme;
  return theme.colorsNew.gray.black;
}, function (_ref86) {
  var active = _ref86.active;
  return active ? css(_templateObject3$6(), function (_ref87) {
    var theme = _ref87.theme;
    return theme.colorsNew.primaryAction.regular;
  }) : null;
}, function (_ref88) {
  var active = _ref88.active,
      theme = _ref88.theme;
  return active ? theme.colorsNew.primaryAction.regular : 'transparent';
}, function (_ref89) {
  var disabled = _ref89.disabled;
  return disabled ? css(_templateObject4$5()) : css(_templateObject5$4(), function (_ref90) {
    var theme = _ref90.theme;
    return theme.colorsNew.primaryAction.regular;
  });
}, function (_ref91) {
  var active = _ref91.active;
  return active && css(_templateObject6$3());
});

function MobileContextualMenu(_ref92) {
  var tabs = _ref92.tabs,
      onElementClicked = _ref92.onElementClicked;
  return React.createElement(VerticalNavigation, null, tabs.map(function (tab) {
    var handleClick = function handleClick(e) {
      tab.onClick(e);
      onElementClicked(e);
    };

    return tab.as === 'button' ? React.createElement(VerticalNavigationElement, Object.assign({
      as: "button",
      key: tab.name,
      onClick: handleClick
    }, tab), tab.name) : React.createElement(VerticalNavigationElement, Object.assign({
      active: tab.active,
      key: tab.name
    }, tab), tab.name);
  }));
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 72px;\n  padding: 16px;\n  background: ", ";\n  width: 100%;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteralLoose(["\n      right: 0;\n    "]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: calc(100vw - 58px);\n  height: 100vh;\n  z-index: 1;\n  background: ", ";\n  position: absolute;\n  top: 0;\n  right: -100%;\n  transition: right 250ms;\n  overflow: hidden;\n\n  ", "\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 8px 8px 0 8px;\n  padding: 8px;\n  height: 56px;\n  width: calc(100% - 16px);\n  background: ", ";\n  display: flex;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 9px;\n  box-shadow: ", ";\n\n  .left > svg {\n    margin-right: 8px;\n  }\n\n  .menu {\n    background: transparent;\n    height: 24px;\n    width: 24px;\n    border: none;\n    background-color: ", ";\n    padding: 0;\n  }\n\n  .left {\n    display: flex;\n    align-items: center;\n  }\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n      display: none;\n    "]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(24, 32, 38, 0.7);\n  z-index: 1;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var Backdrop = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$g(), function (_ref93) {
  var isMenuOpen = _ref93.isMenuOpen;
  return !isMenuOpen && css(_templateObject2$b());
});
var ApplicationHeaderMobileWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$5(), function (_ref94) {
  var theme = _ref94.theme;
  return theme.colorsNew.gray.white;
}, function (_ref95) {
  var theme = _ref95.theme;
  return theme.shadows.rest;
}, function (_ref96) {
  var theme = _ref96.theme;
  return theme.colorsNew.gray.white;
});
var MobileDrawer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$4(), function (_ref97) {
  var theme = _ref97.theme;
  return theme.colorsNew.gray.white;
}, function (_ref98) {
  var isMenuOpen = _ref98.isMenuOpen;
  return isMenuOpen && css(_templateObject7$3());
});
var UserMenu = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8$2(), function (_ref99) {
  var theme = _ref99.theme;
  return theme.colorsNew.gray.grayLight;
});
/* eslint-disable @typescript-eslint/no-unused-vars */

function ApplicationHeaderMobile(_ref) {
  var products = _ref.products,
      isMenuOpen = _ref.isMenuOpen,
      userName = _ref.userName,
      onMenuOpen = _ref.onMenuOpen,
      tabs = _ref.tabs,
      rest = _objectWithoutPropertiesLoose(_ref, ["products", "isMenuOpen", "userName", "onMenuOpen", "tabs", "onProductAcquire"]);

  var product = products.all.find(function (_ref100) {
    var name = _ref100.name;
    return name === products.current;
  });
  var productName = product ? product.display_name : 'Increase';
  return React.createElement("nav", Object.assign({}, rest), React.createElement(ApplicationHeaderMobileWrapper, null, React.createElement("div", {
    className: "left"
  }, React.createElement(IncreaseLogo, null), React.createElement(H3, null, productName)), tabs !== null && React.createElement("button", {
    "aria-label": "abrir men\xFA",
    className: "menu",
    onClick: onMenuOpen
  }, React.createElement(MenuIcon, {
    height: "24",
    width: "24"
  }))), React.createElement(Backdrop, {
    isMenuOpen: isMenuOpen,
    onClick: onMenuOpen
  }), tabs !== null && React.createElement(MobileDrawer, {
    isMenuOpen: isMenuOpen
  }, React.createElement(UserMenu, null, React.createElement(H3, null, userName), React.createElement(MenuLink, {
    href: "#",
    style: {
      color: 'black'
    }
  }, "Ajustes de cuenta")), React.createElement(MobileContextualMenu, {
    onElementClicked: onMenuOpen,
    tabs: tabs
  })));
}

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  height: 38px;\n  width: 100%;\n  padding: 0 8px;\n  display: grid;\n  align-items: center;\n  grid-template-columns: auto 1fr auto;\n  grid-column-gap: 8px;\n  &,\n  button,\n  a,\n  a:hover {\n    color: ", " !important;\n  }\n  button {\n    border: 0;\n    background: transparent;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n  }\n  font-weight: 500;\n  background: ", ";\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var OnTopNotificationContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$h(), function (_ref101) {
  var theme = _ref101.theme;
  return theme.typography.body;
}, function (_ref102) {
  var theme = _ref102.theme;
  return theme.colorsNew.gray.white;
}, function (_ref103) {
  var theme = _ref103.theme,
      variant = _ref103.variant;

  // eslint-disable-next-line default-case
  switch (variant) {
    case 'info':
    default:
      return theme.colorsNew.primaryAction.regular;

    case 'alert':
      return theme.colorsNew.count.regular;

    case 'error':
      return theme.colorsNew.coral.medium;
  }
});

function Icon(_ref104) {
  var variant = _ref104.variant;

  switch (variant) {
    case 'info':
    default:
      return React.createElement(MailIcon, {
        height: "24",
        width: "24"
      });

    case 'alert':
      return React.createElement(WarningCircleIcon, {
        height: "24",
        width: "24"
      });

    case 'error':
      return React.createElement(CancelIcon, {
        height: "24",
        width: "24"
      });
  }
}

function OnTopNotification(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "onClose", "variant"]);

  return React.createElement(OnTopNotificationContainer, Object.assign({
    variant: variant
  }, rest), React.createElement(Icon, {
    variant: variant
  }), React.createElement("div", null, children), React.createElement("button", {
    onClick: onClose
  }, React.createElement(CloseIcon, {
    height: "24",
    width: "24"
  })));
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteralLoose(["\n  min-width: 100%;\n  z-index: 0;\n  position: relative;\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n\n  @media (min-width: ", ") {\n    display: flex;\n  }\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  display: none;\n\n  @media (min-width: ", ") {\n    display: block;\n  }\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n          height: 100vh;\n          overflow: hidden;\n        "]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding-top: 72px;\n\n  ", "\n\n  @media (max-width: ", ") {\n    overflow-x: hidden;\n  }\n  @media (min-width: ", ") {\n    padding-top: 56px;\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var ApplicationLayoutWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$i(), function (_ref105) {
  var isMobileMenuOpen = _ref105.isMobileMenuOpen;
  return isMobileMenuOpen ? css(_templateObject2$c()) : null;
}, function (_ref106) {
  var theme = _ref106.theme;
  return theme.breakpoints.md;
}, function (_ref107) {
  var theme = _ref107.theme;
  return theme.breakpoints.md;
});
var ApplicationHeaderOnlyDesktop = /*#__PURE__*/styled(ApplicationHeader)( /*#__PURE__*/_templateObject3$7(), function (_ref108) {
  var theme = _ref108.theme;
  return theme.breakpoints.md;
});
var ApplicationHeaderOnlyMobile = /*#__PURE__*/styled(ApplicationHeaderMobile)( /*#__PURE__*/_templateObject4$6(), function (_ref109) {
  var theme = _ref109.theme;
  return theme.breakpoints.md;
});
var TabGroupOnlyDesktop = /*#__PURE__*/styled(TabGroupWrapper)( /*#__PURE__*/_templateObject5$6(), function (_ref110) {
  var theme = _ref110.theme;
  return theme.breakpoints.md;
});
var ContentWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$5());

function ApplicationLayout(_ref) {
  var children = _ref.children,
      tabs = _ref.tabs,
      leftContext = _ref.leftContext,
      rightContext = _ref.rightContext,
      onTopNotification = _ref.onTopNotification,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "tabs", "leftContext", "rightContext", "onTopNotification"]);

  var _useState = useState(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var toggleIsMenuOpen = function toggleIsMenuOpen() {
    return setIsMenuOpen(function (isMenuOpen) {
      return !isMenuOpen;
    });
  };

  return React.createElement(React.Fragment, null, onTopNotification && React.createElement(OnTopNotification, Object.assign({
    style: {
      position: 'relative',
      zIndex: 2
    }
  }, onTopNotification)), React.createElement(ApplicationLayoutWrapper, {
    isMobileMenuOpen: isMenuOpen
  }, tabs !== null && React.createElement(TabGroupOnlyDesktop, null, leftContext, React.createElement(TabGroup, null, tabs.map(function (_ref2) {
    var active = _ref2.active,
        name = _ref2.name,
        rest = _objectWithoutPropertiesLoose(_ref2, ["active", "name"]);

    return React.createElement(Tab, Object.assign({
      active: active,
      key: name
    }, rest), name);
  })), rightContext), React.createElement(ApplicationHeaderOnlyDesktop, Object.assign({}, rest)), React.createElement(ApplicationHeaderOnlyMobile, Object.assign({
    isMenuOpen: isMenuOpen,
    onMenuOpen: toggleIsMenuOpen,
    tabs: tabs
  }, rest)), React.createElement(ContentWrapper, null, children)));
}

function _templateObject$j() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  border-radius: 4px;\n  padding: 0\n    ", ";\n  width: max-content;\n  white-space: nowrap;\n  text-decoration: none;\n  cursor: pointer;\n  font-weight: 700;\n  transition: all 100ms ease-in-out;\n  background-color: ", ";\n  border: ", ";\n  color: ", ";\n  ", " {\n    color: ", ";\n  }\n  :not(:disabled):hover ", " {\n    color: ", ";\n  }\n  :not(:disabled):active ", " {\n    color: ", ";\n  }\n  :not(:disabled) {\n    ", "\n  }\n  :disabled {\n    opacity: 0.36;\n  }\n\n  :focus {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  svg {\n    fill: currentColor;\n    margin-right: 4px;\n    /* Same size in small and regular variants */\n    height: 18px;\n    width: 18px;\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var variantStyles = function variantStyles(theme) {
  return {
    primary: {
      basicStyle: {
        background: theme.colorsNew.primaryAction.regular,
        border: theme.colorsNew.gray.subtleBorder,
        color: theme.colorsNew.gray.white
      },
      stateStyles: {
        ':hover': {},
        ':not(:active):hover': {
          boxShadow: '1px 3px 4px rgba(15, 107, 255, 0.27), 1px 2px 2px rgba(15, 107, 255, 0.36)'
        },
        ':active': {
          background: theme.colorsNew.primaryAction.dark
        }
      }
    },
    outline: {
      basicStyle: {
        background: 'transparent',
        border: "1px solid " + theme.colorsNew.primaryAction.regular,
        color: theme.colorsNew.primaryAction.regular
      },
      stateStyles: {
        ':hover': {
          background: theme.colorsNew.primaryAction.regular,
          color: theme.colorsNew.gray.white
        },
        ':active': {
          background: theme.colorsNew.primaryAction.dark,
          border: "1px solid " + theme.colorsNew.primaryAction.dark
        }
      }
    },
    invisible: {
      basicStyle: {
        background: 'transparent',
        border: 'none',
        color: theme.colorsNew.primaryAction.regular
      },
      stateStyles: {
        ':hover': {
          background: theme.colorsNew.primaryAction.alpha
        },
        ':active': {
          background: theme.colorsNew.primaryAction.alpha,
          color: theme.colorsNew.primaryAction.dark
        }
      }
    },
    alert: {
      basicStyle: {
        background: theme.colorsNew.coralAlert.regular,
        border: theme.colorsNew.gray.subtleBorder,
        color: theme.colorsNew.gray.white
      },
      stateStyles: {
        ':hover': {},
        ':not(:active):hover': {
          boxShadow: '1px 3px 4px rgba(223, 19, 33, 0.27), 1px 2px 2px rgba(223, 19, 33, 0.36)'
        },
        ':active': {
          background: theme.colorsNew.coralAlert.dark
        }
      }
    }
  };
};

var BaseButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$j(), function (_ref111) {
  var size = _ref111.size;
  return size === 'small' ? typography$1('cell') : typography$1('body');
}, function (_ref112) {
  var size = _ref112.size;
  return size === 'small' ? '30px' : '40px';
}, function (_ref113) {
  var icon = _ref113.icon,
      size = _ref113.size;
  if (icon) return '8px';
  return size === 'small' ? '8px' : '20px';
}, function (_ref114) {
  var _ref114$buttonType = _ref114.buttonType,
      buttonType = _ref114$buttonType === void 0 ? 'primary' : _ref114$buttonType,
      theme = _ref114.theme;
  return variantStyles(theme)[buttonType].basicStyle.background;
}, function (_ref115) {
  var _ref115$buttonType = _ref115.buttonType,
      buttonType = _ref115$buttonType === void 0 ? 'primary' : _ref115$buttonType,
      theme = _ref115.theme;
  return variantStyles(theme)[buttonType].basicStyle.border;
}, function (_ref116) {
  var _ref116$buttonType = _ref116.buttonType,
      buttonType = _ref116$buttonType === void 0 ? 'primary' : _ref116$buttonType,
      theme = _ref116.theme;
  return variantStyles(theme)[buttonType].basicStyle.color;
}, InlineText, function (_ref117) {
  var _ref117$buttonType = _ref117.buttonType,
      buttonType = _ref117$buttonType === void 0 ? 'primary' : _ref117$buttonType,
      theme = _ref117.theme;
  return variantStyles(theme)[buttonType].basicStyle.color;
}, InlineText, function (_ref118) {
  var _ref118$buttonType = _ref118.buttonType,
      buttonType = _ref118$buttonType === void 0 ? 'primary' : _ref118$buttonType,
      theme = _ref118.theme;
  return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    variantStyles(theme)[buttonType].stateStyles[':hover']['color']
  );
}, InlineText, function (_ref119) {
  var _ref119$buttonType = _ref119.buttonType,
      buttonType = _ref119$buttonType === void 0 ? 'primary' : _ref119$buttonType,
      theme = _ref119.theme;
  return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    variantStyles(theme)[buttonType].stateStyles[':active']['color']
  );
}, function (_ref120) {
  var _ref120$buttonType = _ref120.buttonType,
      buttonType = _ref120$buttonType === void 0 ? 'primary' : _ref120$buttonType,
      theme = _ref120.theme;
  return variantStyles(theme)[buttonType].stateStyles;
}, function (_ref121) {
  var theme = _ref121.theme;
  return theme.colorsNew.increase.light;
}); // eslint-disable-next-line @typescript-eslint/no-unused-vars

var Button = function Button(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "icon"]);

  return React.createElement(BaseButton, Object.assign({
    icon: icon
  }, rest), icon, " ", children);
};

function _templateObject$k() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var Appear = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$k());

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  box-shadow: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  position: absolute;\n  top: 4px;\n  animation: ", " 100ms ease-in;\n  left: 0;\n  min-width: 240px;\n  display: flex;\n  flex-direction: column;\n  padding: 3px;\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0;\n  border-radius: 4px;\n  padding: 12px;\n  text-align: right;\n  background: ", ";\n\n  :not(:disabled) {\n    cursor: pointer;\n  }\n\n  :hover {\n    background: ", ";\n  }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-right: 0;\n  :focus {\n    background: ", ";\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 28px;\n  margin-left: 8px;\n  border-left: 1px solid ", ";\n\n  svg {\n    width: 10px;\n    height: 5px;\n  }\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonMenuButtonArrow = /*#__PURE__*/styled.div.attrs({
  children: React.createElement(ArrowDropdownDown, null)
})( /*#__PURE__*/_templateObject$l(), function (_ref122) {
  var theme = _ref122.theme;
  return theme.colorsNew.gray.subtleBorder;
});
var ButtonMenuButton = /*#__PURE__*/styled(Button).attrs(function (_ref123) {
  var children = _ref123.children;
  return {
    children: React.createElement(React.Fragment, null, children, " ", React.createElement(ButtonMenuButtonArrow, null))
  };
})( /*#__PURE__*/_templateObject2$d(), function (_ref124) {
  var theme = _ref124.theme;
  return theme.colorsNew.primaryAction.dark;
});
var ButtonMenuItem = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject3$8(), function (_ref125) {
  var theme = _ref125.theme;
  return theme.colorsNew.gray.white;
}, function (_ref126) {
  var theme = _ref126.theme;
  return theme.colorsNew.increase.light;
});
var Menu$1 = /*#__PURE__*/styled.div.attrs({
  role: 'menu'
})( /*#__PURE__*/_templateObject4$7(), function (_ref127) {
  var theme = _ref127.theme;
  return theme.colorsNew.gray.white;
}, function (_ref128) {
  var theme = _ref128.theme;
  return theme.shadows.elevateCast;
}, function (_ref129) {
  var theme = _ref129.theme;
  return theme.colorsNew.gray.subtleBorder;
}, Appear);

function ButtonMenu(_ref) {
  var children = _ref.children,
      text = _ref.text,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "text"]);

  return React.createElement(FloatingMenu, {
    renderTrigger: function renderTrigger(props, _ref130) {
      var toggleShowMenu = _ref130.toggleShowMenu;
      return React.createElement(ButtonMenuButton, Object.assign({}, props, {
        onClick: toggleShowMenu
      }, rest), text);
    }
  }, function (props) {
    return React.createElement(Menu$1, null, children(props));
  });
}

function _templateObject$m() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: scale(0);\n  }\n\n  95% {\n    transform: scale(1.05);\n  }\n\n  98% {\n    transform: scale(0.98);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var NaturalGrow = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$m());

function _templateObject5$7() {
  var data = _taggedTemplateLiteralLoose(["\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  path {\n    color: var(--fill-color);\n    stroke: currentColor;\n    stroke-width: 1px;\n  }\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transform: scale(0);\n  pointer-events: none;\n\n  ", ":checked ~ & {\n    transform: scale(1);\n    animation: ", " 200ms cubic-bezier(0, 0.85, 0.81, 1.15);\n  }\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  box-sizing: border-box;\n  opacity: 0;\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  border: 0;\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n          border: 2px solid var(--border-color);\n        "]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n          background: var(--background-color);\n        "]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteralLoose(["\n  --background-color: ", ";\n  --fill-color: ", ";\n  --border-color: ", ";\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  padding: 0;\n  ", "\n  border-radius: 2px;\n  position: relative;\n  box-sizing: border-box;\n  transition: box-shadow 200ms;\n\n  :focus-within {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n  }\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

var CheckboxInputWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$n(), function (_ref131) {
  var theme = _ref131.theme;
  return theme.colorsNew.increase.light30;
}, function (_ref132) {
  var theme = _ref132.theme;
  return theme.colorsNew.gray.white;
}, function (_ref133) {
  var theme = _ref133.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref134) {
  var checked = _ref134.checked;
  return checked ? css(_templateObject2$e()) : css(_templateObject3$9());
}, function (_ref135) {
  var theme = _ref135.theme;
  return theme.colorsNew.increase.light;
});
var CheckboxInputControl = /*#__PURE__*/styled.input.attrs({
  type: 'checkbox'
})( /*#__PURE__*/_templateObject4$8());
var CheckboxInputFill = /*#__PURE__*/styled(CheckIcon)( /*#__PURE__*/_templateObject5$7(), CheckboxInputControl, NaturalGrow);

function CheckboxInput(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      _onChange = _ref.onChange,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "indeterminate", "checked", "defaultChecked", "onChange", "className", "style"]);

  var _useState = useState(checked || defaultChecked),
      realChecked = _useState[0],
      setRealChecked = _useState[1];

  return React.createElement(CheckboxInputWrapper, {
    checked: checked === undefined ? realChecked : checked,
    className: className,
    style: style
  }, React.createElement(CheckboxInputControl, Object.assign({
    checked: checked,
    defaultChecked: defaultChecked,
    id: id,
    onChange: function onChange(e) {
      if (checked === undefined) setRealChecked(e.target.checked);
      _onChange && _onChange(e);
    }
  }, rest)), React.createElement(CheckboxInputFill, null));
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteralLoose(["\n      & label {\n        cursor: pointer;\n      }\n    "]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n  opacity: ", ";\n\n  ", ";\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var CheckboxWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$o(), function (_ref136) {
  var size = _ref136.size;
  return size === 'small' ? typography$1('cell') : typography$1('body');
}, function (_ref137) {
  var disabled = _ref137.disabled;
  return disabled ? 0.2 : 1;
}, function (_ref138) {
  var disabled = _ref138.disabled;
  return !disabled && css(_templateObject2$f());
});

function Checkbox(_ref) {
  var id = _ref.id,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      disabled = _ref.disabled,
      size = _ref.size,
      style = _ref.style,
      other = _objectWithoutPropertiesLoose(_ref, ["id", "label", "labelHidden", "disabled", "size", "style"]);

  return React.createElement(CheckboxWrapper, {
    disabled: disabled,
    size: size
  }, React.createElement(CheckboxInput, Object.assign({}, other, {
    "aria-label": label,
    disabled: disabled,
    id: id,
    style: _extends({}, style, {
      marginRight: '8px'
    }),
    title: labelHidden ? label : undefined
  })), !labelHidden && React.createElement("label", {
    htmlFor: id
  }, label));
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  padding: 16px;\n  flex: 1;\n"]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$8() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: ", ";\n  width: 100%;\n  border-top-left-radius: 9px;\n  border-top-right-radius: 9px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject5$8 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteralLoose(["\n      cursor: pointer;\n    "]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n          box-shadow: ", ";\n        "]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteralLoose(["\n          box-shadow: ", ";\n        "]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border: 0;\n  box-sizing: border-box;\n  border-radius: 9px;\n  display: flex;\n  padding: 0;\n  height: 140px;\n  flex-direction: column;\n  ", " hover {\n    box-shadow: ", ";\n  }\n\n  :hover button {\n    background: ", ";\n    color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper$1 = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$p(), function (_ref139) {
  var theme = _ref139.theme;
  return theme.colorsNew.gray.graySLight;
}, function (_ref140) {
  var active = _ref140.active,
      theme = _ref140.theme;
  return active ? css(_templateObject2$g(), theme.shadows.pressed) : css(_templateObject3$a(), theme.shadows.rest);
}, function (_ref141) {
  var theme = _ref141.theme;
  return theme.shadows.elevate;
}, function (_ref142) {
  var theme = _ref142.theme;
  return theme.colorsNew.primaryAction.regular;
}, function (_ref143) {
  var theme = _ref143.theme;
  return theme.colorsNew.gray.white;
}, function (_ref144) {
  var active = _ref144.active;
  return !active && css(_templateObject4$9());
});
var Header = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$8(), function (_ref145) {
  var active = _ref145.active,
      variant = _ref145.variant,
      theme = _ref145.theme;
  if (active) return theme.colorsNew.primaryAction.regular;
  if (variant === 'neutral') return theme.colorsNew.gray.grayLight;
  return theme.colorsNew.increase.light;
}, function (_ref146) {
  var active = _ref146.active,
      theme = _ref146.theme;
  return active ? theme.colorsNew.gray.white : theme.colorsNew.gray.black;
});
var Body = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$6(), function (_ref147) {
  var theme = _ref147.theme;
  return theme.typography.cell;
});

function ContentCard(_ref) {
  var actionText = _ref.actionText,
      onAction = _ref.onAction,
      title = _ref.title,
      children = _ref.children,
      active = _ref.active,
      variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["actionText", "onAction", "title", "children", "active", "variant"]);

  return React.createElement(Wrapper$1, Object.assign({}, rest, {
    active: active,
    onClick: onAction
  }), React.createElement(Header, {
    active: active,
    variant: variant
  }, React.createElement(H2, null, title), !active && React.createElement(Button, {
    buttonType: "outline",
    onClick: onAction,
    size: "small"
  }, actionText)), React.createElement(Body, null, children));
}

function Currency(_ref148) {
  var value = _ref148.value,
      currency = _ref148.currency,
      _ref148$language = _ref148.language,
      language = _ref148$language === void 0 ? navigator.language : _ref148$language;

  if (isNaN(value)) {
    return null;
  }

  var options = {
    minimumFractionDigits: 2,
    style: 'currency',
    currency: currency
  };
  var numberFormatter = new Intl.NumberFormat(language, options);
  return React.createElement(React.Fragment, null, numberFormatter.format(value));
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteralLoose(["\n          ::after {\n            content: '*';\n            display: inline;\n            width: min-content;\n            margin-left: 1px;\n            color: ", ";\n          }\n        "]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: inline-flex;\n  flex-direction: row;\n  font-weight: 500;\n  line-height: 12px;\n  ", "\n  white-space: nowrap;\n\n  &[for] {\n    cursor: pointer;\n  }\n\n  &[hidden] {\n    display: none;\n  }\n\n  ", "\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

var Label$1 = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject$q(), /*#__PURE__*/typography$1('inputLabel'), function (_ref149) {
  var inline = _ref149.inline;
  return !inline && "margin-bottom: 6px;";
}, function (_ref150) {
  var required = _ref150.required;
  return required ? css(_templateObject2$h(), function (_ref151) {
    var theme = _ref151.theme;
    return theme.colorsNew.increase.regular;
  }) : null;
});

function _templateObject$r() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: -webkit-box;\n  font-size: 13px;\n  line-height: 16px;\n  margin-top: 3px;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

var LabelError = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject$r(), function (_ref152) {
  var theme = _ref152.theme;
  return theme.colorsNew.coralAlert.regular;
});

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n      label {\n        color: ", ";\n      }\n\n      input {\n        border-color: ", ";\n\n        :-moz-ui-invalid {\n          box-shadow: none;\n        }\n      }\n    "]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteralLoose(["\n      label {\n        margin-right: 6px;\n      }\n    "]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  align-items: ", ";\n  flex-direction: ", ";\n  ", "\n  width: ", ";\n  ", "\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

var InputWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$s(), function (_ref153) {
  var inline = _ref153.inline;
  return inline ? 'center' : 'start';
}, function (_ref154) {
  var inline = _ref154.inline;
  return inline ? 'row' : 'column';
}, function (_ref155) {
  var inline = _ref155.inline;
  return inline && css(_templateObject2$i());
}, function (_ref156) {
  var width = _ref156.width;
  return width ? width : '100%';
}, function (_ref157) {
  var error = _ref157.error,
      theme = _ref157.theme;
  return error && css(_templateObject3$b(), theme.colorsNew.coralAlert.dark, theme.colorsNew.coralAlert.regular);
});

function _templateObject$t() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  appearance: none;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  outline: none;\n  margin: 0;\n  padding: ", ";\n  padding-left: ", ";\n  width: 100%;\n  resize: none;\n  text-align: inherit;\n  transition: border 200ms, box-shadow 200ms;\n\n  :disabled {\n    opacity: 0.36;\n  }\n\n  :focus {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n\n  ::placeholder,\n  ::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  :focus,\n  :focus-within {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  :not(:disabled):hover {\n    border: 1px solid ", ";\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var InputStyledBase = /*#__PURE__*/styled.input.attrs(function (_ref158) {
  var htmlSize = _ref158.htmlSize,
      size = _ref158.size;
  return {
    size: htmlSize,
    controlSize: size
  };
})( /*#__PURE__*/_templateObject$t(), /*#__PURE__*/typography$1('cell'), function (_ref159) {
  var theme = _ref159.theme;
  return theme.colorsNew.gray.white;
}, function (_ref160) {
  var theme = _ref160.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref161) {
  var controlSize = _ref161.controlSize;
  return controlSize === 'small' ? '6px 11px' : '11px';
}, function (_ref162) {
  var type = _ref162.type;
  return type === 'search' ? '36px' : null;
}, function (_ref163) {
  var theme = _ref163.theme;
  return theme.colorsNew.increase.light50;
}, function (_ref164) {
  var theme = _ref164.theme;
  return theme.colorsNew.gray.black;
}, function (_ref165) {
  var theme = _ref165.theme;
  return theme.colorsNew.gray.grayBold;
}, function (_ref166) {
  var theme = _ref166.theme;
  return theme.colorsNew.increase.light;
}, function (_ref167) {
  var theme = _ref167.theme;
  return theme.colorsNew.increase.light50;
});

function InputBase(_ref) {
  var className = _ref.className,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? function (inputProps) {
    return React.createElement(InputStyledBase, Object.assign({}, inputProps));
  } : _ref$children,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      value = _ref.value,
      style = _ref.style,
      width = _ref.width,
      errorMessage = _ref.errorMessage,
      inputClassName = _ref.inputClassName,
      inputStyle = _ref.inputStyle,
      inline = _ref.inline,
      required = _ref.required,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "children", "disabled", "id", "label", "labelHidden", "type", "value", "style", "width", "errorMessage", "inputClassName", "inputStyle", "inline", "required", "size"]);

  return React.createElement(InputWrapper, {
    className: className,
    error: errorMessage ? true : false,
    inline: inline,
    style: style,
    width: width
  }, !labelHidden && React.createElement(Label$1, {
    htmlFor: id,
    inline: inline,
    required: required
  }, label), children(_extends({}, rest, {
    'aria-label': labelHidden ? label : undefined,
    className: inputClassName,
    disabled: disabled,
    id: id,
    name: id,
    required: required,
    size: size,
    style: inputStyle,
    title: labelHidden ? label : undefined,
    type: type,
    value: value
  })), errorMessage && React.createElement(LabelError, null, errorMessage));
}

var InputText = function InputText(props) {
  return React.createElement(InputBase, Object.assign({}, props, {
    type: "text"
  }));
};

function _templateObject2$j() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteralLoose(["\n  left: 8px;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  height: ", ";\n  width: ", ";\n  display: inline-flex;\n  align-items: center;\n  color: ", ";\n\n  *:focus-within > & {\n    color: ", ";\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var IconContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$u(), function (_ref168) {
  var size = _ref168.size;
  return size === 'small' ? '30px' : '40px';
}, function (_ref169) {
  var size = _ref169.size;
  return size === 'small' ? '30px' : '40px';
}, function (_ref170) {
  var theme = _ref170.theme;
  return theme.colorsNew.gray.grayBold;
}, function (_ref171) {
  var theme = _ref171.theme;
  return theme.colorsNew.gray.black;
});
var Wrapper$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$j());

var InputSearch = function InputSearch(props) {
  return React.createElement(InputBase, Object.assign({}, props, {
    type: "search"
  }), function (inputProps) {
    return React.createElement(Wrapper$2, null, React.createElement(InputStyledBase, Object.assign({}, inputProps)), React.createElement(IconContainer, {
      size: props.size
    }, React.createElement(MagnifierIcon, {
      height: "24px",
      width: "24px"
    })));
  });
};

function _templateObject2$k() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteralLoose(["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  height: ", ";\n  width: 40px;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 0;\n  display: inline-flex;\n  align-items: center;\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

var IconContainer$1 = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$v(), function (_ref172) {
  var size = _ref172.size;
  return size === 'small' ? '30px' : '40px';
});
var Wrapper$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$k());

var InputPassword = function InputPassword(props) {
  var _useState = useState(true),
      hidden = _useState[0],
      setHidden = _useState[1];

  var handleClick = function handleClick() {
    if (hidden && props.onShowPassword) {
      props.onShowPassword();
    }

    return setHidden(!hidden);
  };

  return React.createElement(React.Fragment, null, React.createElement(InputBase, Object.assign({}, props, {
    type: hidden === true ? 'password' : 'text'
  }), function (inputProps) {
    return React.createElement(Wrapper$3, null, React.createElement(InputStyledBase, Object.assign({}, inputProps)), React.createElement(IconContainer$1, {
      "aria-label": "toggle show password",
      onClick: handleClick,
      size: props.size,
      type: "button"
    }, hidden === true ? React.createElement(EyeSlashedIcon, {
      height: "22px",
      width: "22px"
    }) : React.createElement(EyeIcon, {
      height: "22px",
      width: "22px"
    })));
  }));
};

function _templateObject2$l() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-right: 6px;\n  padding-left: ", ";\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 4px;\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  .prefix {\n    align-items: center;\n    display: flex;\n    font-size: 13px;\n    height: 100%;\n    line-height: 14px;\n    justify-content: center;\n    pointer-events: none;\n    position: absolute;\n    width: 20px;\n  }\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}

var InputContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$w());
var InputStyled = /*#__PURE__*/styled(InputStyledBase)( /*#__PURE__*/_templateObject2$l(), function (_ref173) {
  var prefix = _ref173.prefix;
  return prefix ? '20px' : '12px';
});

var InputNumber = function InputNumber(_ref) {
  var prefix = _ref.prefix,
      rest = _objectWithoutPropertiesLoose(_ref, ["prefix"]);

  return React.createElement(InputBase, Object.assign({}, rest), function (inputProps) {
    return React.createElement(React.Fragment, null, React.createElement(InputContainer, null, prefix && React.createElement("span", {
      className: "prefix"
    }, prefix), React.createElement(InputStyled, Object.assign({}, inputProps, {
      type: "number"
    }))));
  });
};

var TextArea = function TextArea(props) {
  return React.createElement(InputBase, Object.assign({
    as: "textarea"
  }, props));
};

function _templateObject5$9() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n  min-width: max-content;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 8px;\n\n  /* Some CSS magic for being over the border */\n  height: calc(100% + 2px);\n  margin: -1px;\n\n  input:hover + * & {\n    box-shadow: 1px 2px 3px rgba(15, 107, 255, 0.27), 1px 2px 2px rgba(15, 107, 255, 0.36);\n  }\n"]);

  _templateObject5$9 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 8px;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0;\n\n  input:disabled + & {\n    opacity: 0.16;\n  }\n\n  input:not(:disabled):hover + & {\n    border: 1px solid ", ";\n  }\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = _taggedTemplateLiteralLoose(["\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  position: relative;\n  display: flex;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}

var InputControlWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$x());
var Input = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject2$m());
var InputSubstitute = /*#__PURE__*/styled(InputStyledBase)( /*#__PURE__*/_templateObject3$c(), function (_ref174) {
  var theme = _ref174.theme;
  return theme.colorsNew.gray.black;
});
var ValueContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$a());
var InnerLabel = /*#__PURE__*/styled(CellText)( /*#__PURE__*/_templateObject5$9(), function (_ref175) {
  var theme = _ref175.theme;
  return theme.colorsNew.primaryAction.regular;
}, function (_ref176) {
  var theme = _ref176.theme;
  return theme.colorsNew.gray.white;
});

var InputFile = function InputFile(_ref) {
  var innerLabel = _ref.innerLabel,
      onChange = _ref.onChange,
      _ref$noFilesText = _ref.noFilesText,
      noFilesText = _ref$noFilesText === void 0 ? 'Ningún archivo seleccionado' : _ref$noFilesText,
      rest = _objectWithoutPropertiesLoose(_ref, ["innerLabel", "onChange", "noFilesText"]);

  var _useState = useState(null),
      file = _useState[0],
      setFile = _useState[1];

  var inputValue = file !== null ? file.name : noFilesText;

  var handleFileSelected = function handleFileSelected(f) {
    setFile(f);
    onChange(f);
  };

  return React.createElement(InputBase, Object.assign({}, rest), function (inputProps) {
    return React.createElement(React.Fragment, null, React.createElement(InputControlWrapper, null, React.createElement(Input, Object.assign({}, inputProps, {
      onChange: function onChange(e) {
        return handleFileSelected(e.target.files && e.target.files[0]);
      },
      type: "file"
    })), React.createElement(InputSubstitute, {
      as: "label",
      disabled: inputProps.disabled,
      htmlFor: inputProps.id,
      size: "normal"
    }, React.createElement(ValueContainer, null, inputValue), React.createElement(InnerLabel, null, innerLabel || React.createElement(MdiArrowUpIcon, {
      height: "24",
      width: "24"
    })))));
  });
};

function _templateObject$y() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 12px 8px;\n  width: 300px;\n  box-shadow: ", ";\n\n  button {\n    background: transparent;\n    border: none;\n  }\n\n  .react-calendar__navigation__label {\n    ", "\n    text-transform: capitalize;\n  }\n\n  .react-calendar__navigation {\n    margin-bottom: 16px;\n    justify-content: flex-start;\n  }\n\n  .react-calendar__navigation__arrow {\n    display: inline-flex;\n    align-items: center;\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n\n  .react-calendar__navigation__label:not(:disabled) {\n    cursor: pointer;\n  }\n\n  .react-calendar__year-view__months__month,\n  .react-calendar__decade-view__years__year,\n  .react-calendar__century-view__decades__decade {\n    ", "\n    text-transform: capitalize;\n    padding: 8px 0;\n\n    > abbr {\n      padding: 4px;\n      border: 1px solid transparent;\n    }\n  }\n\n  .react-calendar__month-view__weekdays__weekday {\n    ", "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    > abbr {\n      text-decoration: none;\n    }\n  }\n\n  .react-calendar__month-view__days__day,\n  .react-calendar__year-view__months__month,\n  .react-calendar__year-view__yeart__year,\n  .react-calendar__year-view__decades__decade {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n\n  .react-calendar__tile.react-calendar__month-view__days__day {\n    ", "\n    height: 27px;\n    width: 27px;\n    margin: 2px 0;\n    padding: 0 6px;\n    > abbr {\n      height: 100%;\n      width: 100%;\n      border-radius: 3px;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    &.react-calendar__tile--rangeEnd > abbr,\n    &.react-calendar__tile--rangeStart > abbr {\n      border-radius: 3px;\n    }\n  }\n\n  .react-calendar__tile.react-calendar__year-view__months__month {\n    ", "\n    > abbr {\n      height: 100%;\n      width: 100%;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    &.react-calendar__tile--rangeEnd > abbr {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n    }\n    &.react-calendar__tile--rangeStart > abbr {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n    }\n\n    &.react-calendar__tile--rangeStart ~ .react-calendar__tile--active,\n    &.react-calendar__tile--rangeStart ~ .react-calendar__tile--hasActive {\n      > abbr {\n        background: ", ";\n        color: ", ";\n      }\n    }\n    &.react-calendar__tile--hasActive > abbr,\n    &.react-calendar__tile--rangeStart.react-calendar__tile--active > abbr,\n    &.react-calendar__tile--rangeStart.react-calendar__tile--hasActive > abbr,\n    &.react-calendar__tile--rangeEnd.react-calendar__tile--active > abbr,\n    &.react-calendar__tile--rangeEnd.react-calendar__tile--hasActive > abbr {\n      background: ", ";\n      color: ", ";\n    }\n  }\n\n  .react-calendar__tile--rangeStart.react-calendar__tile--active > abbr,\n  .react-calendar__tile--rangeStart.react-calendar__tile--hasActive > abbr,\n  .react-calendar__tile--rangeEnd.react-calendar__tile--active > abbr,\n  .react-calendar__tile--rangeEnd.react-calendar__tile--hasActive > abbr {\n    background: ", ";\n    color: ", ";\n  }\n\n  .react-calendar__tile.react-calendar__month-view__days__day {\n    &.react-calendar__tile--rangeStart ~ .react-calendar__tile--active,\n    &.react-calendar__tile--rangeStart ~ .react-calendar__tile--hasActive {\n      background: ", ";\n      color: ", ";\n\n      &:nth-child(7n) {\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;\n      }\n\n      &:nth-child(7n + 1) {\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n      }\n    }\n    &.react-calendar__tile--rangeStart.react-calendar__tile--active,\n    &.react-calendar__tile--rangeStart.react-calendar__tile--hasActive {\n      background: linear-gradient(\n        90deg,\n        transparent 50%,\n        ", " 50%\n      );\n    }\n    &.react-calendar__tile--rangeEnd.react-calendar__tile--hasActive,\n    &.react-calendar__tile--rangeEnd.react-calendar__tile--active {\n      background: linear-gradient(\n        -90deg,\n        transparent 50%,\n        ", " 50%\n      );\n    }\n\n    &.react-calendar__tile--rangeBothEnds.react-calendar__tile--active,\n    &.react-calendar__tile--rangeBothEnds.react-calendar__tile--hasActive {\n      background: transparent;\n    }\n\n    &.react-calendar__month-view__days__day--neighboringMonth {\n      opacity: 0.45;\n      color: ", ";\n    }\n\n    &.react-calendar__month-view__days__day:disabled {\n      opacity: 0.16;\n      color: ", ";\n    }\n  }\n\n  .react-calendar__tile--now:not(.react-calendar__tile--hasActive):not(.react-calendar__tile--active)\n    > abbr {\n    border: 1px solid ", ";\n    border-radius: 3px;\n  }\n\n  .react-calendar__tile--hover {\n    background: ", ";\n  }\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}

var Datepicker = /*#__PURE__*/styled(Calendar).attrs({
  prev2Label: null,
  next2Label: null,
  prevLabel: React.createElement(ArrowLeftIcon, {
    height: "24",
    width: "24"
  }),
  nextLabel: React.createElement(ArrowRightIcon, {
    height: "24",
    width: "24"
  }),
  calendarType: 'US',
  formatShortWeekday: function formatShortWeekday(_locale, date) {
    return format$1(date, 'EEEEE', {
      locale: es
    }).toLocaleUpperCase();
  },
  navigationLabel: function navigationLabel(_ref177) {
    var date = _ref177.date;
    return format$1(date, 'MMMM Y', {
      locale: es
    });
  }
})( /*#__PURE__*/_templateObject$y(), function (_ref178) {
  var theme = _ref178.theme;
  return theme.colorsNew.gray.white;
}, function (_ref179) {
  var theme = _ref179.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref180) {
  var theme = _ref180.theme;
  return theme.shadows.rest;
}, /*#__PURE__*/typography$1('body'), /*#__PURE__*/typography$1('cell'), /*#__PURE__*/typography$1('body'), /*#__PURE__*/typography$1('cell'), /*#__PURE__*/typography$1('cell'), function (_ref181) {
  var theme = _ref181.theme;
  return theme.colorsNew.increase.light70;
}, function (_ref182) {
  var theme = _ref182.theme;
  return theme.colorsNew.increase.dark;
}, function (_ref183) {
  var theme = _ref183.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref184) {
  var theme = _ref184.theme;
  return theme.colorsNew.gray.white;
}, function (_ref185) {
  var theme = _ref185.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref186) {
  var theme = _ref186.theme;
  return theme.colorsNew.gray.white;
}, function (_ref187) {
  var theme = _ref187.theme;
  return theme.colorsNew.increase.light70;
}, function (_ref188) {
  var theme = _ref188.theme;
  return theme.colorsNew.increase.dark;
}, function (_ref189) {
  var theme = _ref189.theme;
  return theme.colorsNew.increase.light70;
}, function (_ref190) {
  var theme = _ref190.theme;
  return theme.colorsNew.increase.light70;
}, function (_ref191) {
  var theme = _ref191.theme;
  return theme.colorsNew.gray.black;
}, function (_ref192) {
  var theme = _ref192.theme;
  return theme.colorsNew.gray.black;
}, function (_ref193) {
  var theme = _ref193.theme;
  return theme.colorsNew.increase.dark;
}, function (_ref194) {
  var theme = _ref194.theme;
  return theme.colorsNew.increase.light;
});

function _templateObject3$d() {
  var data = _taggedTemplateLiteralLoose(["\n      border-right: 1px solid ", ";\n    "]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 4px;\n  pointer-events: none;\n  top: 0;\n  margin: 4px 0;\n  height: calc(100% - 8px);\n  width: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  ", "\n\n  *:focus-within ~ & {\n    border-right: 1px solid transparent;\n    border-radius: 4px;\n    color: ", ";\n    background: ", ";\n  }\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

function parseDateString(dateString, format) {
  return parse(dateString, format, new Date());
}

var Wrapper$4 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$z());
var IconWrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$n(), function (_ref195) {
  var size = _ref195.size;
  return size === 'small' ? '24px' : '34px';
}, function (_ref196) {
  var theme = _ref196.theme;
  return theme.colorsNew.gray.blackLight;
}, function (_ref197) {
  var size = _ref197.size;
  return size !== 'small' && css(_templateObject3$d(), function (_ref198) {
    var theme = _ref198.theme;
    return theme.colorsNew.gray.grayMedium;
  });
}, function (_ref199) {
  var theme = _ref199.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref200) {
  var theme = _ref200.theme;
  return theme.colorsNew.gray.grayLight;
});

function DateInputUncontrolledInput(_ref) {
  var className = _ref.className,
      value = _ref.value,
      _onChange = _ref.onChange,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'dd/MM/yyyy' : _ref$dateFormat,
      _ref$datepickerProps = _ref.datepickerProps,
      datepickerProps = _ref$datepickerProps === void 0 ? {} : _ref$datepickerProps,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "value", "onChange", "dateFormat", "datepickerProps"]);

  return React.createElement(FloatingMenu, {
    className: className,
    renderTrigger: function renderTrigger(triggerProps, _ref201) {
      var setShowMenu = _ref201.setShowMenu;
      return React.createElement(InputBase, Object.assign({}, rest, triggerProps, {
        inputStyle: {
          paddingLeft: rest.size === 'small' ? '32px' : '48px'
        },
        onFocus: function onFocus() {
          return setShowMenu(true);
        },
        readOnly: true,
        value: value
      }), function (inputProps) {
        return React.createElement(Wrapper$4, null, React.createElement(InputStyledBase, Object.assign({}, inputProps, {
          readOnly: true
        })), React.createElement(IconWrapper$1, {
          size: rest.size
        }, React.createElement(EventIcon, null)));
      });
    }
  }, function (_ref202) {
    var toggleShowMenu = _ref202.toggleShowMenu;
    return React.createElement("div", {
      role: "menu",
      style: {
        position: 'absolute',
        top: '4px'
      }
    }, React.createElement(Datepicker, Object.assign({}, datepickerProps, {
      onChange: function onChange(date) {
        toggleShowMenu();
        _onChange && _onChange(date);
      },
      value: parseDateString(value, dateFormat)
    })));
  });
}

function DateInputControlledInput(_ref2) {
  var props = _objectWithoutPropertiesLoose(_ref2, ["uncontrolled"]);

  var _useState = useState(new Date()),
      date = _useState[0],
      setDate = _useState[1];

  return React.createElement(DateInputUncontrolledInput, Object.assign({}, props, {
    onChange: setDate,
    value: format(date, 'dd/MM/yyyy')
  }));
}

function DateInput(props) {
  if (props.uncontrolled === true) return React.createElement(DateInputControlledInput, Object.assign({}, props));
  return React.createElement(DateInputUncontrolledInput, Object.assign({}, props));
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteralLoose(["\n      border-right: 1px solid ", ";\n    "]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 4px;\n  pointer-events: none;\n  top: 0;\n  margin: 4px 0;\n  height: calc(100% - 8px);\n  width: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  ", "\n\n  *:focus-within ~ & {\n    border-right: 1px solid transparent;\n    border-radius: 4px;\n    color: ", ";\n    background: ", ";\n  }\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}

var IconWrapper$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$A(), function (_ref203) {
  var size = _ref203.size;
  return size === 'small' ? '24px' : '34px';
}, function (_ref204) {
  var theme = _ref204.theme;
  return theme.colorsNew.gray.blackLight;
}, function (_ref205) {
  var size = _ref205.size;
  return size !== 'small' && css(_templateObject2$o(), function (_ref206) {
    var theme = _ref206.theme;
    return theme.colorsNew.gray.grayMedium;
  });
}, function (_ref207) {
  var theme = _ref207.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref208) {
  var theme = _ref208.theme;
  return theme.colorsNew.gray.grayLight;
});
var Wrapper$5 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$e());

function DateRangeInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'dd/MM/yyyy' : _ref$dateFormat,
      _ref$datepickerProps = _ref.datepickerProps,
      datepickerProps = _ref$datepickerProps === void 0 ? {} : _ref$datepickerProps,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "onChange", "dateFormat", "datepickerProps"]);

  return React.createElement(FloatingMenu, {
    renderTrigger: function renderTrigger(triggerProps, _ref209) {
      var setShowMenu = _ref209.setShowMenu;
      return React.createElement(InputBase, Object.assign({}, rest, triggerProps, {
        inputStyle: {
          paddingLeft: rest.size === 'small' ? '32px' : '48px'
        },
        onFocus: function onFocus() {
          return setShowMenu(true);
        },
        readOnly: true,
        value: value.map(function (date) {
          return format$1(date, dateFormat);
        }).join(' - ')
      }), function (inputProps) {
        return React.createElement(Wrapper$5, null, React.createElement(InputStyledBase, Object.assign({}, inputProps)), React.createElement(IconWrapper$2, {
          size: rest.size
        }, React.createElement(EventIcon, null)));
      });
    }
  }, function (_ref210) {
    var toggleShowMenu = _ref210.toggleShowMenu;
    return React.createElement("div", {
      role: "menu",
      style: {
        position: 'absolute',
        top: '4px'
      }
    }, React.createElement(Datepicker, Object.assign({}, datepickerProps, {
      onChange: function onChange(dates) {
        toggleShowMenu();

        _onChange(dates);
      },
      selectRange: true,
      value: value
    })));
  });
}

var NON_SORTABLE_FILTER_TYPE_SELECT_OPTIONS = [{
  value: 'equals',
  name: 'Es igual a'
}, {
  value: 'contains',
  name: 'Contiene'
}];
var SORTABLE_FILTER_TYPE_SELECT_OPTIONS = [{
  value: 'equals',
  name: 'Es igual a'
}, {
  value: 'between',
  name: 'Está entre'
}, {
  value: 'greaterThan',
  name: 'Mayor que'
}, {
  value: 'lowerThan',
  name: 'Menor que'
}];

function _templateObject3$f() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  width: ", ";\n  border-left: 1px solid ", ";\n  pointer-events: none;\n\n  select:focus-within ~ &,\n  select:active ~ & {\n    background-color: ", ";\n    border-left: 1px solid transparent;\n    border-radius: 4px;\n  }\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  height: ", ";\n  padding: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  vertical-align: middle;\n  appearance: none;\n  background: transparent;\n  margin: 0;\n  outline: 0;\n  text-align: inherit;\n  position: relative;\n  width: 100%;\n  transition: all 200ms;\n\n  :focus {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  &:active,\n  &:focus {\n    border: 1px solid ", ";\n  }\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}

var SelectInput = /*#__PURE__*/styled.select( /*#__PURE__*/_templateObject$B(), /*#__PURE__*/typography$1('cell'), function (_ref211) {
  var size = _ref211.size;
  return size === 'small' ? '30px' : '40px';
}, function (_ref212) {
  var size = _ref212.size;
  return size === 'small' ? '6px 49px 6px 11px' : '11px 49px 11px 11px';
}, function (_ref213) {
  var theme = _ref213.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref214) {
  var theme = _ref214.theme;
  return theme.colorsNew.increase.light;
}, function (_ref215) {
  var theme = _ref215.theme;
  return theme.colorsNew.increase.light50;
});
var ArrowWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$p(), function (_ref216) {
  var size = _ref216.size;
  return size === 'small' ? '24px' : '34px';
}, function (_ref217) {
  var size = _ref217.size;
  return size === 'small' ? '24px' : '34px';
}, function (_ref218) {
  var theme = _ref218.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref219) {
  var theme = _ref219.theme;
  return theme.colorsNew.gray.grayLight;
});
var InputWrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$f());

function Select(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React.createElement(InputBase, Object.assign({}, props), function (inputProps) {
    return React.createElement(InputWrapper$1, null, React.createElement(SelectInput, Object.assign({}, inputProps), children), React.createElement(ArrowWrapper, {
      size: inputProps.size
    }, React.createElement(ArrowDropdownDown, null)));
  });
}

function SelectOptGroup(props) {
  return React.createElement("optgroup", Object.assign({}, props));
}

function SelectOption(props) {
  return React.createElement("option", Object.assign({}, props));
}

function isKindEnabled(kind, config) {
  if (config === undefined) return true;
  return Object.entries(config.enabledKinds).filter(function (_ref220) {
    var _ref221 = _slicedToArray(_ref220, 2),
        value = _ref221[1];

    return value;
  }).map(function (_ref222) {
    var _ref223 = _slicedToArray(_ref222, 1),
        key = _ref223[0];

    return key;
  }).includes(kind);
}

var DATE_DEFAULT_FILTER_BY_KIND = {
  equals: function equals(field) {
    return {
      field: field,
      kind: 'equals',
      value: format(new Date(), 'dd/MM/yyyy')
    };
  },
  greaterThan: function greaterThan(field) {
    return {
      field: field,
      kind: 'greaterThan',
      value: format(new Date(), 'dd/MM/yyyy')
    };
  },
  lowerThan: function lowerThan(field) {
    return {
      field: field,
      kind: 'lowerThan',
      value: format(new Date(), 'dd/MM/yyyy')
    };
  },
  between: function between(field) {
    return {
      field: field,
      kind: 'between',
      value: {
        from: format(new Date(), 'dd/MM/yyyy'),
        to: format(new Date(), 'dd/MM/yyyy')
      }
    };
  }
};

function rangeToDaterange(range) {
  return [parse$1(range.from, 'dd/MM/yyyy', new Date()), parse$1(range.to, 'dd/MM/yyyy', new Date())];
}

function FilterInputDate(_ref) {
  var label = _ref.label,
      _onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "onChange", "value"]);

  var kinds = SORTABLE_FILTER_TYPE_SELECT_OPTIONS.filter(function (_ref224) {
    var v = _ref224.value;
    return isKindEnabled(v, value.field.config);
  });
  return React.createElement(Grid, Object.assign({
    rowGap: 1
  }, rest), React.createElement(Select, {
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;
      var newFilter = DATE_DEFAULT_FILTER_BY_KIND[eventValue](value.field);

      _onChange(newFilter);
    },
    size: "small",
    value: value.kind
  }, kinds.map(function (_ref225) {
    var value = _ref225.value,
        name = _ref225.name;
    return React.createElement(SelectOption, {
      key: name,
      value: value
    }, name);
  })), value.kind === 'between' ? React.createElement(DateRangeInput, {
    id: "filter." + value.field.name + ".value",
    label: label,
    labelHidden: true,
    onChange: function onChange(daterange) {
      _onChange(_extends({}, value, {
        value: {
          from: format(daterange[0], 'dd/MM/yyyy'),
          to: format(daterange[1], 'dd/MM/yyyy')
        }
      }));
    },
    size: "small",
    value: rangeToDaterange(value.value)
  }) : React.createElement(DateInput, {
    id: "filter." + value.field.name + ".value",
    label: label,
    labelHidden: true,
    onChange: function onChange(date) {
      _onChange(_extends({}, value, {
        value: format(date, 'dd/MM/yyyy')
      }));
    },
    size: "small",
    value: value.value
  }));
}

function FilterInputSelect(_ref) {
  var value = _ref.value,
      label = _ref.label,
      _onChange = _ref.onChange,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "label", "onChange"]);

  return React.createElement("div", Object.assign({}, rest), React.createElement(Select, {
    id: "filter." + value.field.name + ".value",
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(_extends({}, value, {
        value: eventValue
      }));
    },
    required: true,
    size: "small",
    value: value.value
  }, value.field.options.map(function (_ref226) {
    var value = _ref226.value,
        name = _ref226.name;
    return React.createElement(SelectOption, {
      key: name,
      value: value
    }, name);
  })));
}

function FilterInputText(_ref) {
  var value = _ref.value,
      label = _ref.label,
      _onChange = _ref.onChange,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "label", "onChange"]);

  var kinds = NON_SORTABLE_FILTER_TYPE_SELECT_OPTIONS.filter(function (_ref227) {
    var v = _ref227.value;
    return isKindEnabled(v, value.field.config);
  });
  return React.createElement(Grid, Object.assign({
    rowGap: 1
  }, rest), React.createElement(Select, {
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(_extends({}, value, {
        kind: eventValue
      }));
    },
    size: "small",
    value: value.kind
  }, kinds.map(function (_ref228) {
    var value = _ref228.value,
        name = _ref228.name;
    return React.createElement(SelectOption, {
      key: name,
      value: value
    }, name);
  })), React.createElement(InputText, {
    id: "filter." + value.field.name + ".value",
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(_extends({}, value, {
        value: eventValue
      }));
    },
    required: true,
    size: "small",
    value: value.value
  }));
}

var NUMBER_DEFAULT_FILTER_BY_KIND = {
  equals: function equals(field) {
    return {
      field: field,
      kind: 'equals',
      value: 0
    };
  },
  greaterThan: function greaterThan(field) {
    return {
      field: field,
      kind: 'greaterThan',
      value: 0
    };
  },
  lowerThan: function lowerThan(field) {
    return {
      field: field,
      kind: 'lowerThan',
      value: 0
    };
  },
  between: function between(field) {
    return {
      field: field,
      kind: 'between',
      value: {
        from: 0,
        to: 0
      }
    };
  }
};

function FilterInputNumber(_ref) {
  var label = _ref.label,
      _onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "onChange", "value"]);

  var kinds = SORTABLE_FILTER_TYPE_SELECT_OPTIONS.filter(function (_ref229) {
    var v = _ref229.value;
    return isKindEnabled(v, value.field.config);
  });
  return React.createElement(Grid, Object.assign({
    rowGap: 1
  }, rest), React.createElement(Select, {
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(NUMBER_DEFAULT_FILTER_BY_KIND[eventValue](value.field));
    },
    size: "small",
    value: value.kind
  }, kinds.map(function (_ref230) {
    var value = _ref230.value,
        name = _ref230.name;
    return React.createElement(SelectOption, {
      key: name,
      value: value
    }, name);
  })), value.kind === 'between' ? React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, auto)',
      gridColumnGap: '8px',
      alignItems: 'center'
    }
  }, React.createElement(InputNumber, {
    id: "filter." + value.field.name + ".value.from",
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(_extends({}, value, {
        value: _extends({}, value.value, {
          from: parseFloat(eventValue)
        })
      }));
    },
    size: "small",
    value: value.value.from
  }), "y", React.createElement(InputNumber, {
    id: "filter." + value.field.name + ".value.to",
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(_extends({}, value, {
        value: _extends({}, value.value, {
          to: parseFloat(eventValue)
        })
      }));
    },
    size: "small",
    value: value.value.to
  })) : React.createElement(InputNumber, {
    id: "filter." + value.field.name + ".value",
    label: label,
    labelHidden: true,
    onChange: function onChange(e) {
      var eventValue = e.target.value;

      _onChange(_extends({}, value, {
        value: parseFloat(eventValue)
      }));
    },
    size: "small",
    value: value.value
  }));
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  padding: 8px;\n\n  :not(:first-child) {\n    margin-top: 8px;\n  }\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 8px;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0;\n  border-top: 1px solid ", ";\n  margin: 8px 0;\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  width: ", ";\n  border-left: 1px solid ", ";\n  pointer-events: none;\n\n  select:focus-within ~ &,\n  select:active ~ & {\n    background-color: ", ";\n    border-left: 1px solid transparent;\n    border-radius: 4px;\n  }\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject6$7 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$a() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject5$a = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  width: calc(100%);\n  padding: 4px 12px;\n\n  ", "\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$q() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 40px;\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$C() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  padding: 12px 0;\n  position: absolute;\n  top: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  border-radius: 4px;\n  display: block;\n  border: 1px solid ", ";\n  box-shadow: ", ";\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}

var Menu$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$C(), function (_ref231) {
  var theme = _ref231.theme;
  return theme.colorsNew.gray.white;
}, function (_ref232) {
  var theme = _ref232.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref233) {
  var theme = _ref233.theme;
  return theme.shadows.elevateCast;
});
var FakeInput = /*#__PURE__*/styled(InputStyledBase).attrs({
  as: 'button',
  type: 'button'
})( /*#__PURE__*/_templateObject2$q());
var Label$2 = /*#__PURE__*/styled(CellText).attrs({
  as: 'label'
})( /*#__PURE__*/_templateObject3$g(), function (_ref234) {
  var hidden = _ref234.hidden;
  return hidden && 'display: none;';
});
var OptionName = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject4$b());
var InputWrapper$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$a());
var CheckboxWrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$7());
var ArrowWrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$4(), function (_ref235) {
  var size = _ref235.size;
  return size === 'small' ? '24px' : '34px';
}, function (_ref236) {
  var size = _ref236.size;
  return size === 'small' ? '24px' : '34px';
}, function (_ref237) {
  var theme = _ref237.theme;
  return theme.colorsNew.gray.grayMedium;
}, function (_ref238) {
  var theme = _ref238.theme;
  return theme.colorsNew.gray.grayLight;
});
var Separator$2 = /*#__PURE__*/styled.hr( /*#__PURE__*/_templateObject8$3(), function (_ref239) {
  var theme = _ref239.theme;
  return theme.colorsNew.gray.grayMedium;
});
var MenuHeader = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9$2());
var SelectionButton = /*#__PURE__*/styled(BasicLink).attrs({
  as: 'button'
})( /*#__PURE__*/_templateObject10$1(), function (_ref240) {
  var theme = _ref240.theme;
  return theme.typography.cell;
});

function defaultSelectionRenderer(values, options) {
  if (values.length === 0 || values.length === options.length) {
    return 'Todos seleccionados';
  }

  var names = options.filter(function (_ref241) {
    var value = _ref241.value;
    return values.includes(value);
  }).map(function (_ref242) {
    var name = _ref242.name;
    return name;
  });
  if (names.length === 1) return names[0];
  if (names.length === 2) return names.join(' y ');
  return names.slice(0, 2).join(', ') + " y " + (names.length - 2) + " m\xE1s";
}

function SelectMultiple(_ref) {
  var options = _ref.options,
      values = _ref.value,
      _onChange = _ref.onChange,
      hasSearch = _ref.hasSearch,
      hasClearButton = _ref.hasClearButton,
      _ref$clearButtonText = _ref.clearButtonText,
      clearButtonText = _ref$clearButtonText === void 0 ? 'Limpiar seleccionados' : _ref$clearButtonText,
      _ref$selectAllButtonT = _ref.selectAllButtonText,
      selectAllButtonText = _ref$selectAllButtonT === void 0 ? 'Seleccionar todo' : _ref$selectAllButtonT,
      _ref$renderSelection = _ref.renderSelection,
      renderSelection = _ref$renderSelection === void 0 ? defaultSelectionRenderer : _ref$renderSelection,
      rest = _objectWithoutPropertiesLoose(_ref, ["options", "value", "onChange", "hasSearch", "hasClearButton", "clearButtonText", "selectAllButtonText", "renderSelection"]);

  var _useState = useState(''),
      search = _useState[0],
      setSearch = _useState[1];

  var label = renderSelection(values, options);
  var hasHeader = hasClearButton || hasSearch;
  var allValuesSelected = options.length === values.length;
  return React.createElement(InputBase, Object.assign({}, rest), function (_ref2) {
    var id = _ref2.id,
        inputProps = _objectWithoutPropertiesLoose(_ref2, ["id"]);

    return React.createElement(FloatingMenu, Object.assign({
      onmountOnHide: false,
      renderTrigger: function renderTrigger(triggerProps, _ref243) {
        var toggleShowMenu = _ref243.toggleShowMenu;
        return React.createElement(InputWrapper$2, Object.assign({}, triggerProps), React.createElement(FakeInput, {
          onClick: toggleShowMenu,
          size: rest.size,
          title: label
        }, label), React.createElement(ArrowWrapper$1, {
          size: rest.size
        }, React.createElement(ArrowDropdownDown, null)));
      },
      style: {
        width: '100%'
      }
    }, rest), function (_ref244) {
      var wrapperRef = _ref244.wrapperRef;

      var _wrapperRef$current;

      return React.createElement(Menu$2, {
        size: rest.size,
        style: {
          minWidth: (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.getBoundingClientRect().width
        }
      }, hasHeader && React.createElement(MenuHeader, null, hasSearch && React.createElement(InputSearch, {
        id: "search",
        label: "Buscar",
        labelHidden: true,
        onChange: function onChange(e) {
          setSearch(e.target.value);
        },
        placeholder: "Buscar",
        value: search
      }), hasClearButton && React.createElement(SelectionButton, {
        onClick: function onClick() {
          if (_onChange) {
            var newSelection = allValuesSelected ? [] : options.map(function (_ref245) {
              var value = _ref245.value;
              return value;
            });

            _onChange(newSelection);
          }
        }
      }, allValuesSelected ? clearButtonText : selectAllButtonText), React.createElement(Separator$2, null), ' '), options.map(function (_ref246) {
        var name = _ref246.name,
            value = _ref246.value;
        return React.createElement(Label$2, {
          hidden: !name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
          htmlFor: "" + id + value,
          key: value,
          title: name
        }, React.createElement(CheckboxWrapper$1, {
          key: value
        }, React.createElement(CheckboxInput, Object.assign({}, inputProps, {
          checked: values.includes(value),
          id: "" + id + value,
          name: id,
          onChange: function onChange(e) {
            var target = e.target;
            var newValues;

            if (target.checked) {
              newValues = [].concat(_toConsumableArray(values), [target.value]);
            } else {
              newValues = values.filter(function (v) {
                return v !== target.value;
              });
            }

            _onChange && _onChange(newValues);
          },
          style: {
            marginRight: '8px'
          },
          value: value
        }))), React.createElement(OptionName, null, name));
      }));
    });
  });
}

function FilterInputSelectMultiple(_ref) {
  var value = _ref.value,
      label = _ref.label,
      _onChange = _ref.onChange,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "label", "onChange"]);

  return React.createElement(SelectMultiple, Object.assign({
    hasClearButton: value.field.hasClearButton,
    hasSearch: value.field.hasSearch,
    id: "filter." + value.field.name + ".value",
    label: label,
    labelHidden: true,
    onChange: function onChange(val) {
      var eventValue = val;

      _onChange(_extends({}, value, {
        value: eventValue
      }));
    },
    options: value.field.options,
    renderSelection: value.field.renderSelection,
    size: "small",
    value: value.value
  }, rest));
}

function FilterInput(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "onChange", "value"]);

  switch (value.field.type) {
    case 'select':
      return React.createElement(FilterInputSelect, Object.assign({
        label: label,
        onChange: onChange,
        value: value
      }, rest));

    case 'selectMultiple':
      return React.createElement(FilterInputSelectMultiple, Object.assign({
        label: label,
        onChange: onChange,
        value: value
      }, rest));

    case 'text':
      return React.createElement(FilterInputText, Object.assign({
        label: label,
        onChange: onChange,
        value: value
      }, rest));

    case 'number':
      return React.createElement(FilterInputNumber, Object.assign({
        label: label,
        onChange: onChange,
        value: value
      }, rest));

    case 'date':
      return React.createElement(FilterInputDate, Object.assign({
        label: label,
        onChange: onChange,
        value: value
      }, rest));

    default:
      return null;
  }
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 6px;\n  padding-left: 24px;\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 6px 0;\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}

var FilterControlWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$D());
var FilterInputWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$r());
var Row = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$h());

function defaultFilter(field) {
  switch (field.type) {
    case 'date':
      return {
        value: format(new Date(), 'dd/MM/yyyy'),
        kind: 'equals',
        field: field
      };

    case 'number':
      return {
        value: 0,
        kind: 'equals',
        field: field
      };

    case 'text':
      return {
        value: '',
        kind: 'equals',
        field: field
      };

    case 'select':
      return {
        value: field.options[0].value,
        field: field
      };

    case 'selectMultiple':
      return {
        value: [],
        field: field
      };

    default:
      throw new Error('invalid field');
  }
}

function FilterControl(_ref247) {
  var _onChange = _ref247.onChange,
      value = _ref247.value;

  var _value$field$config;

  var label = "Filtrar por " + value.field.name;
  var id = "filter." + value.field.name + ".enabled";
  return React.createElement(FilterControlWrapper, null, React.createElement(Row, null, React.createElement(Checkbox, {
    checked: value.enabled,
    disabled: (_value$field$config = value.field.config) === null || _value$field$config === void 0 ? void 0 : _value$field$config.required,
    id: id,
    label: label,
    labelHidden: true,
    onChange: function onChange() {
      if (value.enabled) {
        return _onChange(_extends({}, value, {
          enabled: false
        }));
      }

      return _onChange(_extends({}, value, {
        enabled: true,
        filter: defaultFilter(value.field)
      }));
    }
  }), React.createElement(CellText, {
    as: "label",
    htmlFor: id,
    weight: "bold"
  }, value.field.displayName)), React.createElement(FilterInputWrapper, null, value.enabled && React.createElement(FilterInput, {
    label: label,
    onChange: function onChange(filter) {
      return _onChange(_extends({}, value, {
        filter: filter
      }));
    },
    value: value.filter
  })));
}

function _templateObject4$c() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$c = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$i() {
  var data = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid ", ";\n  padding: 8px 0 0;\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$s() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  box-shadow: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  position: absolute;\n  top: 4px;\n  animation: ", " 100ms ease-in;\n  min-width: 280px;\n  text-align: left;\n  left: 0;\n  padding: 8px;\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$E() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}

var FilterButtonTrigger = /*#__PURE__*/styled(Button)( /*#__PURE__*/_templateObject$E(), function (_ref248) {
  var active = _ref248.active,
      theme = _ref248.theme;
  return active && "background: " + theme.colorsNew.primaryAction.alpha + ";";
});
var Menu$3 = /*#__PURE__*/styled.div.attrs({
  role: 'menu'
})( /*#__PURE__*/_templateObject2$s(), function (_ref249) {
  var theme = _ref249.theme;
  return theme.colorsNew.gray.white;
}, function (_ref250) {
  var theme = _ref250.theme;
  return theme.shadows.elevateCast;
}, function (_ref251) {
  var theme = _ref251.theme;
  return theme.colorsNew.gray.grayMedium;
}, Appear);
var MenuFooter = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$i(), function (_ref252) {
  var theme = _ref252.theme;
  return theme.colorsNew.gray.grayMedium;
});
var MenuBody = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$c());

var getRequired = function getRequired(filters) {
  return Object.entries(filters).reduce(function (newFilters, _ref253) {
    var _ref254 = _slicedToArray(_ref253, 2),
        name = _ref254[0],
        filter = _ref254[1];

    var _filter$field$config;

    if ((_filter$field$config = filter.field.config) === null || _filter$field$config === void 0 ? void 0 : _filter$field$config.required) newFilters[name] = filter;
    return newFilters;
  }, {});
};

function FilterButton(_ref255) {
  var className = _ref255.className,
      fields = _ref255.fields,
      value = _ref255.value,
      onChange = _ref255.onChange;

  var _useState = useState(value),
      filters = _useState[0],
      setFilters = _useState[1];

  var activeFilters = Object.entries(value);
  var activeFilterCount = activeFilters.length;
  return React.createElement("div", {
    className: className
  }, React.createElement(FloatingMenu, {
    closeOnClickOutside: true,
    onClickOutside: function onClickOutside() {
      return setFilters(value);
    },
    onmountOnHide: false,
    renderTrigger: function renderTrigger(props, _ref256) {
      var toggleShowMenu = _ref256.toggleShowMenu,
          showMenu = _ref256.showMenu;
      return React.createElement(FilterButtonTrigger, Object.assign({}, props, {
        active: showMenu,
        buttonType: "invisible",
        icon: activeFilterCount > 0 ? React.createElement(FilterFilledIcon, null) : React.createElement(FilterEmptyIcon, null),
        onClick: toggleShowMenu
      }), activeFilterCount > 0 ? activeFilterCount + " filtros" : 'Filtrar');
    }
  }, function (_ref257) {
    var toggleShowMenu = _ref257.toggleShowMenu;
    return React.createElement(Menu$3, {
      as: "form",
      onSubmit: function onSubmit(e) {
        onChange(filters);
        toggleShowMenu();
        e.preventDefault();
      }
    }, React.createElement(MenuBody, null, fields.map(function (field) {
      var _field$config;

      return React.createElement(FilterControl, {
        key: field.name,
        onChange: function onChange(filter) {
          return setFilters(function (filters) {
            if (filter.enabled) {
              return _extends({}, filters, _defineProperty({}, filter.field.name, filter.filter));
            }

            var newFilters = Object.assign({}, filters);
            delete newFilters[filter.field.name];
            return newFilters;
          });
        },
        value: filters[field.name] ? {
          enabled: true,
          filter: filters[field.name],
          field: field,
          required: ((_field$config = field.config) === null || _field$config === void 0 ? void 0 : _field$config.required) || false
        } : {
          enabled: false,
          field: field,
          filter: defaultFilter(field),
          required: false
        }
      });
    })), React.createElement(MenuFooter, null, React.createElement(Button, {
      buttonType: "invisible",
      onClick: function onClick() {
        var required = getRequired(filters);
        setFilters(required);
        onChange(required);
        toggleShowMenu();
      },
      size: "small",
      type: "button"
    }, "Borrar"), React.createElement(Button, {
      size: "small",
      type: "submit"
    }, "Aplicar")));
  }));
}

function _templateObject6$8() {
  var data = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "]);

  _templateObject6$8 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$b() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  width: max-content;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  padding: 10px;\n\n  ", "\n  :not(:disabled):hover {\n    color: ", ";\n  }\n\n  :disabled {\n    opacity: 0.36;\n  }\n"]);

  _templateObject5$b = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$d() {
  var data = _taggedTemplateLiteralLoose(["\n          text-align: right;\n          align-items: flex-end;\n          right: -32px;\n        "]);

  _templateObject4$d = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$j() {
  var data = _taggedTemplateLiteralLoose(["\n          text-align: left;\n          left: 0;\n        "]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  box-shadow: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  position: absolute;\n  top: 4px;\n  animation: ", " 100ms ease-in;\n  min-width: 65px;\n  display: flex;\n  flex-direction: column;\n  ", "\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  cursor: pointer;\n  background: transparent;\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  width: 32px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  transition: all 200ms;\n\n  :focus {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  :hover,\n  :active,\n  :focus:hover {\n    box-shadow: ", ";\n    border: 1px solid ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}

var MenuTrigger = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$F(), function (_ref258) {
  var theme = _ref258.theme;
  return theme.colorsNew.increase.light;
}, function (_ref259) {
  var theme = _ref259.theme;
  return theme.shadows.elevateCast;
}, function (_ref260) {
  var theme = _ref260.theme;
  return theme.colorsNew.gray.blackLight;
}, function (_ref261) {
  var theme = _ref261.theme;
  return theme.colorsNew.primaryAction.regular;
});
var Menu$4 = /*#__PURE__*/styled.div.attrs({
  role: 'menu'
})( /*#__PURE__*/_templateObject2$t(), function (_ref262) {
  var theme = _ref262.theme;
  return theme.colorsNew.gray.white;
}, function (_ref263) {
  var theme = _ref263.theme;
  return theme.shadows.elevateCast;
}, function (_ref264) {
  var theme = _ref264.theme;
  return theme.colorsNew.gray.blackLight;
}, Appear, function (_ref265) {
  var position = _ref265.position;
  return position === 'bottomRight' ? css(_templateObject3$j()) : css(_templateObject4$d());
});
var MenuItem = /*#__PURE__*/styled.button.attrs({
  role: 'menuitem'
})( /*#__PURE__*/_templateObject5$b(), /*#__PURE__*/typography$1('cell'), function (_ref266) {
  var theme = _ref266.theme,
      variant = _ref266.variant;
  return variant === 'alert' && css(_templateObject6$8(), theme.colorsNew.coralAlert.regular);
}, function (_ref267) {
  var theme = _ref267.theme,
      variant = _ref267.variant;
  return variant === 'alert' ? theme.colorsNew.coralAlert.dark : theme.colorsNew.primaryAction.regular;
});

var MenuButton = function MenuButton(_ref) {
  var position = _ref.position,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["position", "children"]);

  return React.createElement(FloatingMenu, Object.assign({
    renderTrigger: function renderTrigger(triggerProps, _ref268) {
      var toggleShowMenu = _ref268.toggleShowMenu;
      return React.createElement(MenuTrigger, Object.assign({
        "aria-label": "Abrir men\xFA",
        onClick: toggleShowMenu
      }, triggerProps), React.createElement(EllipsisIcon, null));
    }
  }, rest), function (props) {
    return React.createElement(Menu$4, {
      position: position
    }, children(props));
  });
};

function _templateObject$G() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0 16px;\n  margin-top: 16px;\n  margin-bottom: 32px;\n  text-align: ", ";\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}

var Container = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$G(), function (_ref269) {
  var align = _ref269.align;
  return align;
});

var ModalHeader = function ModalHeader(_ref270) {
  var align = _ref270.align,
      children = _ref270.children;
  return React.createElement(Container, {
    align: align
  }, React.createElement(H2, null, children));
};

function _templateObject$H() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  text-align: ", ";\n  overflow-wrap: break-word;\n  margin: 16px 0;\n  padding: 0 16px;\n  &.scrollable {\n    overflow-y: auto;\n    max-height: 60vh;\n  }\n  & p {\n    margin: 0;\n  }\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}

var Container$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$H(), /*#__PURE__*/typography$1('body'), function (_ref271) {
  var align = _ref271.align;
  return align;
});

var ModalContent = function ModalContent(_ref272) {
  var align = _ref272.align,
      children = _ref272.children,
      scrollable = _ref272.scrollable;
  return React.createElement(Container$1, {
    align: align,
    className: scrollable ? 'scrollable' : ''
  }, children);
};

function _templateObject3$k() {
  var data = _taggedTemplateLiteralLoose(["\n          margin: 32px 16px 16px;\n\n          & button:not(:last-child) {\n            margin-right: 0.5rem;\n          }\n        "]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteralLoose(["\n          margin-top: 32px;\n\n          & > * {\n            flex-grow: 1;\n          }\n\n          & > *:first-child {\n            border-radius: 0 0 0 3px;\n            border-right: 0;\n            padding: 0;\n          }\n\n          & > *:last-child {\n            border-radius: 0 0 3px 0;\n          }\n        "]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: ", ";\n  ", ";\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}

var alignments = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center'
};
var Container$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$I(), function (_ref273) {
  var align = _ref273.align;
  return alignments[align || 'left'];
}, function (_ref274) {
  var fullWidthActionButtons = _ref274.fullWidthActionButtons;
  return fullWidthActionButtons ? css(_templateObject2$u()) : css(_templateObject3$k());
});

var ModalFooter = function ModalFooter(_ref275) {
  var align = _ref275.align,
      _ref275$fullWidthActi = _ref275.fullWidthActionButtons,
      fullWidthActionButtons = _ref275$fullWidthActi === void 0 ? false : _ref275$fullWidthActi,
      children = _ref275.children;
  return React.createElement(Container$2, {
    align: align,
    fullWidthActionButtons: fullWidthActionButtons
  }, children);
};

function _templateObject4$e() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  position: absolute;\n  top: 9px;\n  right: 9px;\n  & svg {\n    fill: ", ";\n  }\n"]);

  _templateObject4$e = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$l() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: ", "px;\n  max-width: calc(100vw - 30px);\n  max-height: calc(100vh - 30px);\n  background-color: white;\n  border-radius: 3px;\n  color: ", ";\n  .modal-enter & {\n    opacity: 0;\n    transform: translate(-50%, -100%);\n  }\n  .modal-enter-active & {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n    transition: opacity 200ms ease-out, transform 200ms ease-out;\n  }\n  .modal-exit & {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n  .modal-exit-active & {\n    opacity: 0;\n    transform: translate(-50%, -100%);\n    transition: opacity 200ms ease-out, transform 200ms ease-out;\n  }\n"]);

  _templateObject3$l = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$v() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  .modal-enter & {\n    opacity: 0;\n  }\n  .modal-enter-active & {\n    opacity: 1;\n    transition: opacity 200ms ease-out;\n  }\n  .modal-exit & {\n    opacity: 1;\n  }\n  .modal-exit-active & {\n    opacity: 0;\n    transition: opacity 200ms ease-out;\n  }\n"]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$J() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 10000;\n  overflow: hidden;\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}

var defaultProps = {
  align: 'left',
  okLabel: 'Continuar',
  cancelLabel: 'Cancelar',
  closeOnEscape: true,
  fullWidthActionButtons: false,
  shadeClosable: true,
  shade: true,
  width: 600
};
var ModalWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$J());
var Shade = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$v());
var ModalBody = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$l(), function (_ref276) {
  var width = _ref276.width;
  return width;
}, function (_ref277) {
  var theme = _ref277.theme;
  return theme.colorsNew.gray.black;
});
var IconButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject4$e(), function (_ref278) {
  var theme = _ref278.theme;
  return theme.colorsNew.gray.grayBold;
});

var CloseButton = function CloseButton(_ref279) {
  var onClick = _ref279.onClick;
  return React.createElement(IconButton, {
    as: "a",
    onClick: onClick
  }, React.createElement(CloseIcon, {
    height: "24",
    width: "24"
  }));
};

function Modal(_ref280) {
  var align = _ref280.align,
      children = _ref280.children,
      onClose = _ref280.onClose,
      customFooter = _ref280.customFooter,
      description = _ref280.description,
      fullWidthActionButtons = _ref280.fullWidthActionButtons,
      headerText = _ref280.headerText,
      shade = _ref280.shade,
      visible = _ref280.visible,
      width = _ref280.width,
      cancelLabel = _ref280.cancelLabel,
      onCancel = _ref280.onCancel,
      onOk = _ref280.onOk,
      okLabel = _ref280.okLabel,
      closeOnEscape = _ref280.closeOnEscape,
      shadeClosable = _ref280.shadeClosable;

  var getOrderedButtons = function getOrderedButtons() {
    var buttons = [React.createElement(Button, {
      buttonType: "invisible",
      key: "cancelButton",
      onClick: onCancel
    }, cancelLabel), React.createElement(Button, {
      key: "okButton",
      onClick: onOk
    }, okLabel)];
    return fullWidthActionButtons || align !== 'left' ? buttons : buttons.reverse();
  };

  var handleShadeClick = function handleShadeClick(e) {
    if (shadeClosable) {
      onClose(e);
    }
  };

  var handleEscKey = function handleEscKey(e) {
    if (e.key === 'Escape' && closeOnEscape) {
      onClose(e);
    }
  };

  return React.createElement(UniversalPortal, {
    selector: "body"
  }, React.createElement(CSSTransition, {
    classNames: "modal",
    in: visible,
    mountOnEnter: true,
    timeout: 200,
    unmountOnExit: true
  }, React.createElement(ModalWrapper, {
    onClick: handleShadeClick,
    onKeyUp: handleEscKey
  }, shade && React.createElement(Shade, null), React.createElement(RemoveScrollBar, null), React.createElement(ModalBody, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    width: width
  }, React.createElement(CloseButton, {
    onClick: onClose
  }), children ? children : React.createElement(React.Fragment, null, React.createElement(ModalHeader, {
    align: align
  }, headerText), React.createElement(ModalContent, {
    align: align
  }, description && React.createElement("p", null, description), children), React.createElement(ModalFooter, {
    align: align,
    fullWidthActionButtons: fullWidthActionButtons
  }, customFooter || getOrderedButtons()))))));
}

Modal.defaultProps = defaultProps;

function _templateObject$K() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}

var AppearFromBelow = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$K());

function _templateObject$L() {
  var data = _taggedTemplateLiteralLoose(["\n  background: #ffffff;\n  box-shadow: ", ";\n  border: 1px solid rgba(28, 28, 28, 0.15);\n  border-radius: 3px;\n  padding: 5px 5px 5px 16px;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n  animation: ", " 250ms cubic-bezier(0.55, 0.06, 0.68, 0.19);\n  .info {\n    font-weight: normal;\n  }\n  .error {\n    color: ", ";\n  }\n  .success {\n    color: ", ";\n  }\n  span + span {\n    margin-left: 16px;\n  }\n\n  .buttonGroup {\n    button + button {\n      margin-left: 4px;\n    }\n  }\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}

function Floating(_ref281) {
  var actionText = _ref281.actionText,
      bodyText = _ref281.bodyText,
      cancelText = _ref281.cancelText,
      className = _ref281.className,
      _ref281$type = _ref281.type,
      type = _ref281$type === void 0 ? 'info' : _ref281$type,
      onAction = _ref281.onAction,
      onCancel = _ref281.onCancel;
  return React.createElement("span", {
    className: className
  }, React.createElement("span", {
    className: type
  }, bodyText), React.createElement("span", {
    className: "buttonGroup"
  }, onAction && React.createElement(Button, {
    onClick: onAction,
    size: "small"
  }, actionText), onCancel && React.createElement(Button, {
    buttonType: "invisible",
    onClick: onCancel,
    size: "small"
  }, cancelText)));
}

var FloatingStyled = /*#__PURE__*/styled(Floating)( /*#__PURE__*/_templateObject$L(), function (_ref282) {
  var theme = _ref282.theme;
  return theme.shadows.rest;
}, AppearFromBelow, function (_ref283) {
  var theme = _ref283.theme;
  return theme.colorsNew.coral.medium;
}, function (_ref284) {
  var theme = _ref284.theme;
  return theme.colorsNew.increase.dark30;
});

function _templateObject3$m() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: default;\n  color: inherit;\n\n  &:not(:disabled):hover {\n    cursor: default;\n    border: 1px solid transparent;\n    color: inherit;\n  }\n"]);

  _templateObject3$m = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$w() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n  transition: border 200ms, color 200ms, box-shadow 200ms;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  min-width: max-content;\n  height: 30px;\n  padding: 0 1px;\n  color: ", ";\n  border-radius: 4px;\n  text-align: center;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n\n  :not(:last-child) {\n    margin-right: 3px;\n  }\n\n  :focus {\n    box-shadow: 0 0 0 2px ", ";\n    border: 1px solid ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  :not(:disabled):hover {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n\n  :disabled > svg {\n    opacity: 0.5;\n  }\n"]);

  _templateObject2$w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper$6 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$M());
var PageButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject2$w(), /*#__PURE__*/typography$1('cell'), function (_ref285) {
  var theme = _ref285.theme;
  return theme.colorsNew.gray.blackLight;
}, function (_ref286) {
  var active = _ref286.active,
      theme = _ref286.theme;
  return active ? theme.colorsNew.increase.light : 'transparent';
}, function (_ref287) {
  var active = _ref287.active,
      theme = _ref287.theme;
  return active ? theme.colorsNew.gray.subtleBorder : 'transparent';
}, function (_ref288) {
  var theme = _ref288.theme;
  return theme.colorsNew.increase.light;
}, function (_ref289) {
  var theme = _ref289.theme;
  return theme.colorsNew.increase.light50;
}, function (_ref290) {
  var theme = _ref290.theme;
  return theme.colorsNew.gray.subtleBorder;
}, function (_ref291) {
  var theme = _ref291.theme;
  return theme.colorsNew.increase.regular;
});
var EllipsisButton = /*#__PURE__*/styled(PageButton).attrs({
  as: 'span',
  children: '...'
})( /*#__PURE__*/_templateObject3$m());

var range = function range(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var range = [];

  for (var i = start; i < end; i += step) {
    range.push(i);
  }

  return range;
};

function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      onSelectPage = _ref.onSelectPage,
      rest = _objectWithoutPropertiesLoose(_ref, ["currentPage", "totalPages", "onSelectPage"]);

  var from = currentPage > 2 ? currentPage - 2 : 1;
  var to = Math.min(from + 4, totalPages);
  from = Math.max(to - 4, 1);
  var pagenums = range(from, to + 1);
  return React.createElement(Wrapper$6, Object.assign({}, rest), React.createElement(PageButton, {
    "aria-label": "Anterior",
    disabled: currentPage === 1,
    onClick: function onClick() {
      return onSelectPage(currentPage - 1);
    }
  }, React.createElement(ArrowLeftIcon, {
    height: "24",
    width: "24"
  })), !pagenums.includes(1) && React.createElement(React.Fragment, null, React.createElement(PageButton, {
    active: false,
    disabled: false,
    onClick: function onClick() {
      return onSelectPage(1);
    }
  }, 1), !pagenums.includes(2) && React.createElement(EllipsisButton, null)), pagenums.map(function (n, i) {
    return React.createElement(PageButton, {
      active: n === currentPage,
      disabled: currentPage === n,
      key: i,
      onClick: function onClick() {
        return onSelectPage(n);
      }
    }, n);
  }), !pagenums.includes(totalPages) && React.createElement(React.Fragment, null, !pagenums.includes(totalPages - 1) && React.createElement(EllipsisButton, null), React.createElement(PageButton, {
    active: false,
    disabled: false,
    onClick: function onClick() {
      return onSelectPage(totalPages);
    }
  }, totalPages)), React.createElement(PageButton, {
    "aria-label": "Siguiente",
    disabled: currentPage === totalPages,
    onClick: function onClick() {
      return onSelectPage(currentPage + 1);
    }
  }, React.createElement(ArrowRightIcon, {
    height: "24",
    width: "24"
  })));
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 100%;\n  background: white;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  top: 12px;\n  right: 12px;\n\n  *:hover > & {\n    background: ", ";\n    color: ", ";\n  }\n\n  *:hover > input:checked ~ & {\n    display: none;\n  }\n\n  input:checked ~ &,\n  *:hover > & {\n    display: flex;\n  }\n"]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject6$9 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$c() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: bold;\n"]);

  _templateObject5$c = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$f() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n"]);

  _templateObject4$f = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$n() {
  var data = _taggedTemplateLiteralLoose(["\n          background: transparent;\n          color: ", ";\n\n          :hover {\n            color: ", ";\n            box-shadow: ", ";\n            border: 3px solid ", ";\n            padding: 20px;\n          }\n        "]);

  _templateObject3$n = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$x() {
  var data = _taggedTemplateLiteralLoose(["\n          background: ", ";\n          color: ", ";\n        "]);

  _templateObject2$x = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-shadow: ", ";\n  border-radius: 9px;\n  padding: 23px;\n\n  :focus-within {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  :hover {\n    background: ", ";\n    color: ", ";\n    box-shadow: ", ";\n    border: 3px solid ", ";\n    padding: 20px;\n  }\n\n  ", "\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}

var PathSelectorWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$N(), function (_ref292) {
  var theme = _ref292.theme;
  return theme.shadows.rest;
}, function (_ref293) {
  var theme = _ref293.theme;
  return theme.colorsNew.increase.light;
}, function (_ref294) {
  var theme = _ref294.theme;
  return theme.colorsNew.gray.white;
}, function (_ref295) {
  var theme = _ref295.theme;
  return theme.colorsNew.increase.dark;
}, function (_ref296) {
  var theme = _ref296.theme;
  return theme.shadows.elevate;
}, function (_ref297) {
  var theme = _ref297.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref298) {
  var checked = _ref298.checked,
      theme = _ref298.theme;
  return checked ? css(_templateObject2$x(), theme.colorsNew.increase.regular, theme.colorsNew.gray.white) : css(_templateObject3$n(), theme.colorsNew.gray.blackLight, theme.colorsNew.increase.dark, theme.shadows.elevate, theme.colorsNew.increase.regular);
});
var Input$1 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject4$f());
var Title = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject5$c(), function (_ref299) {
  var theme = _ref299.theme;
  return theme.typography.body;
});
var Body$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$9(), function (_ref300) {
  var theme = _ref300.theme;
  return theme.typography.body;
});
var CheckIconContainer = /*#__PURE__*/styled.div.attrs({
  children: React.createElement(CheckIcon, null)
})( /*#__PURE__*/_templateObject7$5(), function (_ref301) {
  var theme = _ref301.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref302) {
  var theme = _ref302.theme;
  return theme.colorsNew.increase.regular;
}, function (_ref303) {
  var theme = _ref303.theme;
  return theme.colorsNew.gray.white;
});

function PathSelector(_ref) {
  var className = _ref.className,
      title = _ref.title,
      children = _ref.children,
      id = _ref.id,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "title", "children", "htmlTitle", "id"]);

  return React.createElement(PathSelectorWrapper, {
    checked: rest.checked,
    className: className
  }, React.createElement(Title, {
    htmlFor: id
  }, title), React.createElement(Body$1, null, children), React.createElement(CheckIconContainer, null), React.createElement(Input$1, Object.assign({
    id: id,
    name: id,
    type: "radio"
  }, rest)));
}

function _templateObject$O() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}

var RadioButtonControl = /*#__PURE__*/styled.input.attrs({
  type: 'radio'
})( /*#__PURE__*/_templateObject$O());

function _templateObject$P() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  width: calc(100% - 10px);\n  height: calc(100% - 10px);\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  border-radius: 100%;\n  transform: scale(0);\n  pointer-events: none;\n\n  ", ":checked ~ & {\n    transform: scale(1);\n    animation: ", " 200ms cubic-bezier(0, 0.85, 0.81, 1.15);\n  }\n"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}

var RadioButtonFill = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$P(), function (_ref304) {
  var theme = _ref304.theme;
  return theme.colorsNew.increase.light30;
}, RadioButtonControl, NaturalGrow);

function _templateObject$Q() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 20px;\n  width: 20px;\n  position: relative;\n  margin-right: 6px;\n  border-radius: 100%;\n  transition: box-shadow 200ms;\n\n  :focus-within {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n  }\n\n  &::before {\n    content: '';\n    border: 2px solid\n      ", ";\n    border-radius: 100%;\n    box-sizing: border-box;\n    position: absolute;\n    pointer-events: none;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}

var RadioButtonControlWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$Q(), function (_ref305) {
  var theme = _ref305.theme;
  return theme.colorsNew.increase.light;
}, function (_ref306) {
  var checked = _ref306.checked,
      theme = _ref306.theme;
  return checked ? theme.colorsNew.increase.light30 : theme.colorsNew.gray.grayMedium;
});

function _templateObject2$y() {
  var data = _taggedTemplateLiteralLoose(["\n      :not(:first-of-type) {\n        margin-left: 16px;\n      }\n    "]);

  _templateObject2$y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$R() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n\n  ", "\n\n  ", ";\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}

var RadioButtonWrapper = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject$R(), function (_ref307) {
  var size = _ref307.size;
  return size === 'small' ? typography$1('cell') : typography$1('body');
}, function (_ref308) {
  var inline = _ref308.inline;
  return inline ? 'inline-flex' : 'flex';
}, function (_ref309) {
  var inline = _ref309.inline;
  return inline && css(_templateObject2$y());
}, function (_ref310) {
  var disabled = _ref310.disabled,
      theme = _ref310.theme;

  if (disabled) {
    return "\n            opacity: 0.2;\n          ";
  }

  return "\n            &:hover {\n              color: " + theme.colorsNew.gray.black + ";\n            }\n          ";
});

var RadioButton = function RadioButton(_ref) {
  var checked = _ref.checked,
      label = _ref.label,
      disabled = _ref.disabled,
      name = _ref.name,
      inline = _ref.inline,
      size = _ref.size,
      other = _objectWithoutPropertiesLoose(_ref, ["checked", "label", "disabled", "name", "inline", "size"]);

  return React.createElement(RadioButtonWrapper, {
    disabled: disabled,
    inline: inline,
    size: size
  }, React.createElement(RadioButtonControlWrapper, {
    checked: checked
  }, React.createElement(RadioButtonControl, Object.assign({
    checked: checked,
    disabled: disabled,
    name: name
  }, other)), React.createElement(RadioButtonFill, null)), label);
};

function useRadioButton(_ref311) {
  var name = _ref311.name,
      options = _ref311.options,
      defaultSelected = _ref311.defaultSelected;

  var _useState = useState(defaultSelected),
      selected = _useState[0],
      setSelected = _useState[1];

  return options.map(function (_ref312) {
    var label = _ref312.label,
        value = _ref312.value;
    return {
      label: label,
      name: name,
      value: value,
      onClick: function onClick() {
        return setSelected(value);
      },
      checked: selected === value
    };
  });
}

function RadioGroup(_ref) {
  var defaultSelected = _ref.defaultSelected,
      name = _ref.name,
      options = _ref.options,
      inline = _ref.inline,
      rest = _objectWithoutPropertiesLoose(_ref, ["defaultSelected", "name", "options", "inline"]);

  var optionProps = useRadioButton({
    name: name,
    options: options,
    defaultSelected: defaultSelected
  });
  return React.createElement(InputBase, Object.assign({}, rest), function (_ref313) {
    var className = _ref313.className,
        disabled = _ref313.disabled,
        required = _ref313.required,
        style = _ref313.style,
        title = _ref313.title;
    return React.createElement(React.Fragment, null, React.createElement("fieldset", {
      style: {
        margin: 0,
        border: 'none'
      }
    }, optionProps.map(function (props) {
      return React.createElement(RadioButton, Object.assign({
        key: props.value
      }, props, {
        className: className,
        disabled: disabled,
        inline: inline,
        required: required,
        style: style,
        title: title
      }));
    })));
  });
}

function _templateObject$S() {
  var data = _taggedTemplateLiteralLoose(["\n  & .path {\n    stroke-dasharray: 187;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n    stroke: ", ";\n    animation: dash 1.4s ease-in-out infinite;\n  }\n  width: ", "px;\n  height: ", "px;\n  animation: rotator 1.4s linear infinite;\n\n  @keyframes dash {\n    0% {\n      stroke-dashoffset: 187;\n    }\n    50% {\n      stroke-dashoffset: ", ";\n      transform: rotate(135deg);\n    }\n    100% {\n      stroke-dashoffset: 187;\n      transform: rotate(450deg);\n    }\n  }\n  @keyframes rotator {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(270deg);\n    }\n  }\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}

var SVGStyled = /*#__PURE__*/styled.svg( /*#__PURE__*/_templateObject$S(), function (_ref314) {
  var theme = _ref314.theme;
  return theme.colorsNew.increase.light30;
}, function (_ref315) {
  var size = _ref315.size;
  return size ? size : 24;
}, function (_ref316) {
  var size = _ref316.size;
  return size ? size : 24;
}, 187 / 4);

var Spinner = function Spinner(props) {
  return React.createElement(SVGStyled, Object.assign({
    className: "spinner",
    height: "65px",
    viewBox: "0 0 66 66",
    width: "65px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("circle", {
    className: "path",
    cx: "33",
    cy: "33",
    fill: "none",
    r: "30",
    strokeLinecap: "round",
    strokeWidth: "6"
  }));
};

function _templateObject5$d() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 100%;\n  border: 2px solid #b1b1b1;\n  height: 23px;\n  width: 23px;\n"]);

  _templateObject5$d = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$g() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 100%;\n  background: ", ";\n  height: 23px;\n  width: 23px;\n"]);

  _templateObject4$g = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$o() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 64px;\n  display: flex;\n  justify-content: center;\n  padding: 4px 16px 0;\n  border-left: 2px solid\n    ", ";\n"]);

  _templateObject3$o = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$z() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 80px;\n\n  &.stepper-pending,\n  &.stepper-done {\n    ", ", ", " {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2$z = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$T() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}

var Stepper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$T());
var StepperStepWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$z(), Paragraph, H3, function (_ref317) {
  var theme = _ref317.theme;
  return theme.colorsNew.gray.grayBold;
});
var StepperStepIndicatorWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$o(), function (_ref318) {
  var status = _ref318.status,
      theme = _ref318.theme;
  return status === 'pending' ? theme.colorsNew.gray.grayBold : theme.colorsNew.increase.light30;
});
var GreenCircle = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$g(), function (_ref319) {
  var theme = _ref319.theme;
  return theme.colorsNew.increase.light30;
});
var GrayCircumference = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$d());

function StepperStepIndicator(_ref320) {
  var status = _ref320.status;

  // eslint-disable-next-line default-case
  switch (status) {
    case 'current':
      return React.createElement(StepperStepIndicatorWrapper, {
        status: status
      }, React.createElement(GreenCircle, null));

    case 'pending':
      return React.createElement(StepperStepIndicatorWrapper, {
        status: status
      }, React.createElement(GrayCircumference, null));

    case 'done':
      return React.createElement(StepperStepIndicatorWrapper, {
        status: status
      }, React.createElement(CheckIcon, {
        color: "#3FBD9B"
      }));
  }
}

var StepperStep = function StepperStep(_ref) {
  var className = _ref.className,
      description = _ref.description,
      title = _ref.title,
      status = _ref.status,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "description", "title", "status"]);

  return React.createElement(StepperStepWrapper, Object.assign({
    className: className + " stepper-" + status
  }, rest), React.createElement(StepperStepIndicator, {
    status: status
  }), React.createElement("div", null, React.createElement(Paragraph, null, title), React.createElement(H3, null, description)));
};

function _templateObject4$h() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 20px;\n  width: 34px;\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n  border-radius: 10px;\n  box-sizing: border-box;\n  margin: 1px;\n  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  opacity: ", ";\n\n  transition: all 200ms;\n\n  :focus-within {\n    box-shadow: 0 0 0 4px ", ";\n    outline: 0;\n  }\n"]);

  _templateObject4$h = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$p() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  background-color: ", ";\n  border-radius: 100%;\n  transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n\n  ", ":checked ~ & {\n    transform: translateX(14px);\n    transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n"]);

  _templateObject3$p = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$A() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 20px;\n  width: 34px;\n  opacity: 0;\n  box-sizing: border-box;\n  border: 0;\n  margin: 0;\n  cursor: ", ";\n"]);

  _templateObject2$A = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$U() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: grid;\n  width: max-content;\n  grid-template-columns: repeat(2, auto);\n  align-items: center;\n  column-gap: 8px;\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}

var SwitchWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$U(), function (_ref321) {
  var size = _ref321.size;
  return size === 'small' ? typography$1('cell') : typography$1('body');
});
var SwitchControl = /*#__PURE__*/styled.input.attrs({
  type: 'checkbox'
})( /*#__PURE__*/_templateObject2$A(), function (_ref322) {
  var disabled = _ref322.disabled;
  return !disabled ? 'pointer' : 'unset';
});
var SwitchToggle = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$p(), function (_ref323) {
  var checked = _ref323.checked,
      theme = _ref323.theme;
  return checked ? theme.colorsNew.gray.white : theme.colorsNew.gray.blackLight;
}, SwitchControl);
var SwitchControlWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$h(), function (_ref324) {
  var checked = _ref324.checked,
      theme = _ref324.theme;
  return checked ? theme.colorsNew.increase.light30 : theme.colorsNew.gray.subtleBorder;
}, function (_ref325) {
  var checked = _ref325.checked,
      theme = _ref325.theme;
  return checked ? theme.colorsNew.increase.light30 : theme.colorsNew.gray.grayBold;
}, function (_ref326) {
  var disabled = _ref326.disabled;
  return disabled ? 0.36 : 1;
}, function (_ref327) {
  var theme = _ref327.theme;
  return theme.colorsNew.increase.light;
});

function Switch(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      size = _ref.size,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "checked", "id", "name", "label", "labelHidden", "size", "onChange", "disabled"]);

  return React.createElement(SwitchWrapper, {
    size: size
  }, React.createElement(SwitchControlWrapper, {
    checked: checked,
    className: className,
    disabled: disabled
  }, React.createElement(SwitchControl, Object.assign({
    "aria-label": label,
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    onChange: !disabled ? onChange : undefined,
    title: labelHidden ? label : undefined
  }, rest)), React.createElement(SwitchToggle, {
    checked: checked
  })), !labelHidden && React.createElement("label", {
    htmlFor: id
  }, label));
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteralLoose(["\n      text-align: right;\n    "]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$2() {
  var data = _taggedTemplateLiteralLoose(["\n  vertical-align: middle;\n  padding: 0 8px;\n  ", "\n"]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$3() {
  var data = _taggedTemplateLiteralLoose(["\n      text-align: right;\n    "]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  text-align: left;\n  font-weight: 500;\n  height: 42px;\n  vertical-align: middle;\n  padding: 8px;\n  text-transform: uppercase;\n  ", "\n"]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$6() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 3px solid ", ";\n"]);

  _templateObject7$6 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$a() {
  var data = _taggedTemplateLiteralLoose(["\n      tr:nth-child(even) {\n        background: ", ";\n      }\n\n      ", " {\n        border-bottom: none;\n      }\n    "]);

  _templateObject6$a = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$e() {
  var data = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n  font-size: 13px;\n  line-height: 16px;\n  ", "\n"]);

  _templateObject5$e = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$i() {
  var data = _taggedTemplateLiteralLoose(["\n      border-bottom: 1px solid ", ";\n    "]);

  _templateObject4$i = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$q() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  ", "\n"]);

  _templateObject3$q = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$B() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n"]);

  _templateObject2$B = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$V() {
  var data = _taggedTemplateLiteralLoose(["\n  background: white;\n  border: 1px solid ", ";\n  border-radius: 9px;\n  padding: 20px;\n  flex: 1;\n"]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}

var TableWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$V(), function (_ref328) {
  var theme = _ref328.theme;
  return theme.colorsNew.gray.grayMedium;
});
var TableHeader = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$B());
var TableRow = /*#__PURE__*/styled.tr( /*#__PURE__*/_templateObject3$q(), function (_ref329) {
  var double = _ref329.double;
  return double ? '58px' : '40px';
}, function (_ref330) {
  var double = _ref330.double,
      border = _ref330.border;
  return (!double || border) && css(_templateObject4$i(), function (_ref331) {
    var theme = _ref331.theme;
    return theme.colorsNew.gray.grayMedium;
  });
});
var StyledTable = /*#__PURE__*/styled.table( /*#__PURE__*/_templateObject5$e(), function (_ref332) {
  var zebra = _ref332.zebra;
  return zebra && css(_templateObject6$a(), function (_ref333) {
    var theme = _ref333.theme;
    return theme.colorsNew.gray.grayLight;
  }, TableRow);
});
var THead = /*#__PURE__*/styled.thead( /*#__PURE__*/_templateObject7$6(), function (_ref334) {
  var theme = _ref334.theme;
  return theme.colorsNew.gray.black;
});
var Th = /*#__PURE__*/styled.th( /*#__PURE__*/_templateObject8$4(), /*#__PURE__*/typography$1('label'), function (_ref335) {
  var numeric = _ref335.numeric,
      rightAligned = _ref335.rightAligned;
  return (numeric || rightAligned) && css(_templateObject9$3());
});
var Td = /*#__PURE__*/styled.td( /*#__PURE__*/_templateObject10$2(), function (_ref336) {
  var numeric = _ref336.numeric,
      rightAligned = _ref336.rightAligned;
  return (numeric || rightAligned) && css(_templateObject11$1());
});
var NoDataLabel = /*#__PURE__*/styled(Label)( /*#__PURE__*/_templateObject12(), function (_ref337) {
  var theme = _ref337.theme;
  return theme.colorsNew.gray.grayBold;
});

var NoData = function NoData() {
  return React.createElement("div", {
    style: {
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      margin: '16px 0 0'
    }
  }, React.createElement(NoDataIcon, {
    height: "96",
    width: "96"
  }), React.createElement(NoDataLabel, {
    style: {
      marginTop: '8px'
    }
  }, "No hay datos"));
};

var Table = function Table(_ref) {
  var children = _ref.children,
      zebra = _ref.zebra,
      hasData = _ref.hasData,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "zebra", "hasData"]);

  return React.createElement(React.Fragment, null, React.createElement(StyledTable, Object.assign({}, rest, {
    zebra: zebra
  }), children), hasData === false && React.createElement(NoData, null));
};

function _templateObject2$C() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n\n  svg {\n    height: 1em;\n    width: 1em;\n  }\n"]);

  _templateObject2$C = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$W() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: grid;\n  grid-column-gap: 4px;\n  grid-template-columns: repeat(", ", auto);\n  align-items: center;\n  border: 1px solid\n    ", ";\n  color: ", ";\n  background-color: ", ";\n  height: 20px;\n  padding: 0 9px;\n  border-radius: 10px;\n  font-weight: 500;\n  width: max-content;\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}

function callIfFunc(maybeFunc, theme) {
  if (typeof maybeFunc !== 'function') return maybeFunc;
  return maybeFunc(theme);
}

var TagWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$W(), /*#__PURE__*/typography$1('label'), function (_ref338) {
  var icon = _ref338.icon;
  return icon ? '2' : '1';
}, function (_ref339) {
  var colors = _ref339.colors,
      theme = _ref339.theme;
  return callIfFunc(colors.border, theme) || callIfFunc(colors.background, theme);
}, function (_ref340) {
  var colors = _ref340.colors,
      theme = _ref340.theme;
  return callIfFunc(colors.foreground, theme) || theme.colorsNew.gray.white;
}, function (_ref341) {
  var colors = _ref341.colors,
      theme = _ref341.theme;
  return callIfFunc(colors.background, theme);
});
var IconWrapper$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$C(), function (_ref342) {
  var colors = _ref342.colors,
      theme = _ref342.theme;
  return callIfFunc(colors.foreground, theme) || theme.colorsNew.gray.white;
});
/**
 * Don't use with icon
 */

function Tag(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      colors = _ref.colors,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "icon", "colors"]);

  return React.createElement(TagWrapper, Object.assign({
    colors: colors,
    icon: icon
  }, rest), icon && React.createElement(IconWrapper$3, {
    colors: colors
  }, icon), React.createElement("span", null, children));
}

function _templateObject3$r() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  padding: 16px;\n  flex: 1;\n"]);

  _templateObject3$r = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$D() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-bottom-left-radius: 9px;\n  border-bottom-right-radius: 9px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject2$D = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$X() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 9px;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper$7 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$X(), function (_ref343) {
  var theme = _ref343.theme;
  return theme.colorsNew.gray.graySLight;
}, function (_ref344) {
  var theme = _ref344.theme;
  return theme.colorsNew.gray.grayMedium;
});
var Footer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$D(), function (_ref345) {
  var checked = _ref345.checked,
      theme = _ref345.theme;
  return checked ? theme.colorsNew.increase.light : theme.colorsNew.gray.grayLight;
});
var Body$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$r(), function (_ref346) {
  var theme = _ref346.theme;
  return theme.typography.cell;
});

function ToggleCard(_ref) {
  var className = _ref.className,
      id = _ref.id,
      title = _ref.title,
      children = _ref.children,
      statusText = _ref.statusText,
      checked = _ref.checked,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "id", "title", "children", "statusText", "checked"]);

  return React.createElement(Wrapper$7, {
    className: className
  }, React.createElement(Body$2, null, React.createElement(H3, {
    style: {
      marginBottom: '8px'
    }
  }, title), children), React.createElement(Footer, {
    checked: checked
  }, React.createElement(InputLabel, {
    htmlFor: id,
    weight: "bold"
  }, statusText), React.createElement(Switch, Object.assign({
    checked: checked,
    id: id,
    label: statusText,
    labelHidden: true,
    name: id
  }, rest))));
}

export { ApplicationLayout, BaseButton, BasicLink, Button, ButtonMenu, ButtonMenuButton, ButtonMenuItem, Caption, CellText, Checkbox, CheckboxInput, CheckboxInputControl, CheckboxInputFill, ContentCard, Currency, DateInput, DateRangeInput, Datepicker, FilterButton, FilterInput, FloatingMenu, FloatingStyled as FloatingNotification, Grid, H1, H2, H3, InlineText, InputBase, InputFile, InputLabel, InputNumber, InputPassword, InputSearch, InputText, Label, Link, MenuButton, MenuItem, Modal, ModalContent, ModalFooter, ModalHeader, OnTopNotification, Pagination, Paragraph, PathSelector, RadioButton, RadioGroup, Select, SelectMultiple, SelectOptGroup, SelectOption, Spinner, Stepper, StepperStep, SuperHeader, Switch, THead, Table, TableHeader, TableRow, TableWrapper, Tag, Td, TextArea, Th, ThemeProvider, ToggleCard, UniversalPortal, VerticalNavigation, VerticalNavigationElement, color, typography$1 as typography, useOnClickOutside, useRadioButton };